// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-22T20:07:46.471Z
// Property: Aspen Court Apartment Homes (ID: 6767906449166309)
// Collections: 32 amenities, 12 floorplans (live), 38 photos, 84 POIs, 1 reviews, 1 virtual tours, 6 office hours, 2 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162442",
  "multihub_property_id": "6767906449166309",
  "property_external_id": "30948",
  "property_zillow_url": "https://www.zillow.com/apartments/piscataway-nj/aspen-court-apartments/5XrmxY/",
  "property_apartments_url": "https://www.apartments.com/aspen-court-apartments-piscataway-nj/j4zx6h5/",
  "property_google_business_url": "https://www.google.com/maps/place/Aspen+Court+Apartment+Homes/data=!4m2!3m1!1s0x0:0xa91685c9e808cf9f?sa=X&ved=2ahUKEwjyr5fEiriSAxWO1fACHbm8M6wQ_BJ6BAgWEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "EliseAI",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "aspen-court-apartment-homes",
  "property_name": "Aspen Court Apartment Homes",
  "property_website_url": "https://www.liveaspencourt.com/",
  "property_domain": "https://www.liveaspencourt.com/",
  "property_address": "2800 New Brunswick Ave",
  "property_full_address": "2800 New Brunswick Ave, Piscataway, NJ 08854",
  "property_address_1": "2800 New Brunswick Ave",
  "property_address_2": null,
  "property_address_city": "Piscataway",
  "property_address_state": "NJ",
  "property_address_zip_full": "08854-2752",
  "property_address_zip": "08854",
  "property_address_country": "US",
  "property_address_county": "Middlesex County",
  "property_neighborhood_address": "North Middlesex County",
  "property_address_latitude": "40.5734611",
  "property_address_longitude": "-74.4450978",
  "property_email": "aspencourt@aionmanagement.com",
  "property_phone": "(732) 752-4499",
  "property_call_tracking_phone": "888-904-3969",
  "property_company_name": "AION Management ",
  "property_company_url": "https://www.aionmanagement.com",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "Nestled in Piscataway, NJ, Aspen Court Apartment Homes offers spacious one and two-bedroom floor plans designed for your lifestyle. Enjoy amenities like scenic walking trails, a vibrant clubhouse, and a refreshing swimming pool. Embrace community living with resident activities and a pet-friendly atmosphere. Your ideal home awaits!",
  "property_long_description": "<p>At Aspen Court Apartment Homes in Piscataway, NJ, comfort meets convenience. Choose from spacious one and two-bedroom floor plans, complete with modern kitchens and chic finishes. Enjoy unrivaled amenities like a refreshing swimming pool, a vibrant clubhouse, and serene walking trails—all in a pet-friendly community. Elevate your lifestyle today!</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-6951-738d-9653-26847e57c212.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of apartment buildings with a swimming pool and outdoor seating areas.",
    "public_id": "019fcdf2-6951-738d-9653-26847e57c212",
    "storage_key": "property/6767906449166309/019fcdf2-6951-738d-9653-26847e57c212.webp",
    "width": 1920,
    "height": 1279
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "414",
  "property_year_built": "2010",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.34299516908213",
  "property_admin_fee": null,
  "property_application_fee": "50",
  "property_fees_deposit_info": "Security Deposit: $750",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "350",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum 2 pets per apartment, each up to 100 lb.",
  "property_pet_policy_description": "Cats and dogs are welcome. Maximum 2 pets per apartment, each up to 100 lb. One-time pet fee: $300 non‑refundable. Monthly pet rent: $50 for one pet, $75 for two pets.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": null,
  "property_resident_portal_url": "https://aspencourtpiscataway.loftliving.com/login",
  "property_apply_now_url": "https://www.liveaspencourt.com/apply-now",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0268-6b75-72c9-8609-08ae24fef46d.webp",
  "property_primary_logo_media": {
    "alt_text": "Aspen Court Apartment Homes logo",
    "public_id": "019d0268-6b75-72c9-8609-08ae24fef46d",
    "storage_key": "property/6767906449166309/019d0268-6b75-72c9-8609-08ae24fef46d.webp",
    "width": 300,
    "height": 125
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0268-6448-73d7-be42-60d75e5ab9e1.webp",
  "property_secondary_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0268-6448-73d7-be42-60d75e5ab9e1",
    "storage_key": "property/6767906449166309/019d0268-6448-73d7-be42-60d75e5ab9e1.webp",
    "width": 598,
    "height": 250
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0268-a4d6-77fe-aed6-9727deed2b8c.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Aspen Court Apartment Homes logo",
    "public_id": "019d0268-a4d6-77fe-aed6-9727deed2b8c",
    "storage_key": "property/6767906449166309/019d0268-a4d6-77fe-aed6-9727deed2b8c.webp",
    "width": 300,
    "height": 125
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0268-ad0d-73cf-86ab-218ef8a2ddc3.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Aspen Court Apartment Homes logo",
    "public_id": "019d0268-ad0d-73cf-86ab-218ef8a2ddc3",
    "storage_key": "property/6767906449166309/019d0268-ad0d-73cf-86ab-218ef8a2ddc3.webp",
    "width": 300,
    "height": 125
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019fcb00-e4bd-730e-be09-fdc89126e5de.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
  "property_company_logo_media": {
    "alt_text": "AION MANAGEMENT logo",
    "public_id": "019d0264-670c-7240-a629-183122c7de9e",
    "storage_key": "company/5767906449162442/019d0264-670c-7240-a629-183122c7de9e.webp",
    "width": 598,
    "height": 250
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#002142",
  "property_secondary_color": "#494747",
  "property_font_color": "#002142",
  "property_color_4": null,
  "property_color_3": "#f18c20",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "1000 - 1405",
  "property_sqft_min": "1000",
  "property_sqft_max": "1405",
  "property_price_range": "1334 - 3169",
  "property_price_min": "1334",
  "property_price_max": "3169",
  "property_available_units": 11,
  "property_facebook_url": "https://www.facebook.com/AspenCourtAptHomes",
  "property_instagram_url": "https://www.instagram.com/liveaspencourt/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJmePgw0-4w4kRn88I6MmFFqk",
  "property_youtube_url": "https://www.youtube.com/watch?v=K76IqBca10g",
  "property_yelp_url": "https://www.yelp.com/search?find_desc=Apartments&find_loc=South+Plainfield%2C+NJ+07080",
  "property_tiktok_url": "https://www.tiktok.com/@liveaspencourt",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Aspen Court Apartment Homes",
  "property_home_romance_title": "Embrace Your New Life in a Charming Community Retreat",
  "property_home_amenities_blurb": "Welcome to Aspen Court Apartment Homes in Piscataway, NJ, where comfort meets convenience. Choose from spacious one or two-bedroom floor plans, unwind at our outdoor lounge, or invigorate at the fitness center. With pet-friendly amenities and EV charging stations, it's the ideal community for modern living. Your oasis awaits!",
  "property_home_floorplans_blurb": "Welcome to Aspen Court Apartment Homes in Piscataway, NJ, where comfort meets style. Choose from spacious one and two-bedroom floor plans designed to elevate your living experience. Browse our selection today and uncover the ideal space that resonates with your lifestyle, right here at Aspen Court. Your new home awaits!",
  "property_home_gallery_blurb": "Welcome to Aspen Court Apartment Homes in Piscataway, NJ—a vibrant community where comfort meets convenience. Choose between our stylish one- and two-bedroom floor plans while enjoying top-notch amenities like walking trails, a fitness center, and a pet-friendly dog park. Picture yourself living here, surrounded by modern luxury and community spirit!",
  "property_home_neighborhood_blurb": "Welcome to Aspen Court Apartment Homes, where vibrant living meets exceptional convenience in Piscataway, NJ. Nestled near renowned schools, lush parks, and cultural gems like the Zimmerli Art Museum, you’ll enjoy a lifestyle rich in exploration and community. Your perfect one or two-bedroom home awaits!",
  "property_home_reviews_blurb": "Welcome to Aspen Court Apartment Homes, where spacious living meets attentive service in Piscataway, NJ. Resident satisfaction shines through with one stating, “The staff is friendly and caring...the grounds are kept very neat and clean.” Enjoy peaceful strolls, excellent amenities, and a vibrant community spirit right at your doorstep!",
  "property_neighborhood_blurb": "Nestled in vibrant Piscataway, Aspen Court Apartment Homes offers more than just comfort—it's your gateway to a rich tapestry of community life. Discover enriching experiences at local parks, engaging museums, and renowned schools, all just moments away. Unveil the dynamic neighborhood that awaits around you.",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Aspen Court Apartment Homes in Piscataway, NJ, immerse yourself in a lifestyle that combines comfort and convenience. Enjoy modern one and two-bedroom layouts paired with upscale amenities like a refreshing pool, fitness center, and tranquil outdoor lounge. Experience community living at its finest—your new home awaits!",
  "property_applynow_blurb": "Welcome to Aspen Court Apartment Homes, where modern living meets unparalleled comfort in Piscataway, NJ. Choose from stylish one or two-bedroom floor plans while enjoying top-notch amenities like walking trails, a vibrant clubhouse, and a pet-friendly dog park. Lease online today and elevate your lifestyle!",
  "property_contactus_blurb": "At Aspen Court Apartment Homes in Piscataway, NJ, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle. Enjoy modern amenities and a welcoming community. Got questions about your future home? Reach out to our friendly leasing team today for personalized assistance! Your new beginning awaits.",
  "property_faqs_blurb": "At Aspen Court Apartment Homes in Piscataway, NJ, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs. Curious about amenities, lease terms, or community events? Our FAQs page is your go-to resource for all the answers to make your new home experience seamless and welcoming.",
  "property_floorplans_blurb": "At Aspen Court Apartment Homes in Piscataway, NJ, your ideal living space awaits. Choose from thoughtfully designed one-bedroom and two-bedroom floor plans that cater to your lifestyle. Embrace comfort and style—browse our available apartment homes to find the perfect fit for your next chapter!",
  "property_gallery_blurb": "Immerse yourself in the vibrant lifestyle at Aspen Court Apartment Homes in Piscataway, NJ. Choose from one or two-bedroom floor plans featuring modern updates and enjoy amenities like walking trails, a clubhouse, and our friendly dog park. Picture yourself living here, where every day feels like a retreat!",
  "property_interactivemap_blurb": "At Aspen Court Apartment Homes in Piscataway, NJ, find your perfect haven among one- and two-bedroom floor plans. Enjoy amenities like a sparkling swimming pool, pet-friendly dog park, and engaging resident activities. Use our interactive community map to locate your ideal home and experience vibrant living today!",
  "property_pets_blurb": "At Aspen Court Apartment Homes in Piscataway, NJ, your furry companions are part of the family! Enjoy spacious living with a pet-friendly environment, allowing up to two pets—each weighing up to 100 lb. Tail-wagging adventures await; come home to comfort with your pets by your side!",
  "property_referafriend_blurb": "At Aspen Court Apartment Homes in Piscataway, NJ, you’ll find spacious one and two-bedroom floor plans tailored for comfort. Share the experience of exceptional living with your friends—great friends make great neighbors. Refer a friend today and elevate your community vibe! ",
  "property_residentaccess_blurb": "Welcome to Aspen Court Apartment Homes in Piscataway, NJ, where your comfort awaits in thoughtfully designed one and two-bedroom floor plans. Elevate your living experience with tailored amenities. Access your resident portal now for easy rent payments, maintenance requests, and all the conveniences you deserve. Join us today!",
  "property_reviews_blurb": "At Aspen Court Apartment Homes in Piscataway, NJ, residents rave about the spacious layouts and attentive community feel. One happy tenant shares, \"It's like a family... the grounds are kept very neat and clean.\" Join a peaceful environment that offers ample outdoor space, top-notch amenities, and a welcoming atmosphere! ",
  "property_created_at": "1757003743394",
  "property_scheduletour_blurb": "At Aspen Court Apartment Homes in Piscataway, NJ, find your ideal space with our thoughtfully designed one and two-bedroom floor plans. Experience a vibrant community that feels like home—schedule a tour today and hear firsthand from our residents about their joyful living experience!",
  "property_thankyou_blurb": "Thank you for reaching out to Aspen Court Apartment Homes in Piscataway, NJ! With beautifully designed one and two-bedroom floor plans, we offer the perfect space to call home. A member of our team will be in touch soon to assist you on your journey to finding your ideal apartment.",
  "property_virtualtours_blurb": "Step into serenity at Aspen Court Apartment Homes in Piscataway, NJ, where comfort meets style. With spacious one and two-bedroom floor plans, our community invites you to envision your next chapter. Take a virtual tour and experience the charm of your future home, just waiting for your personal touch!",
  "property_copyright": "2026 All Rights Reserved. Aspen Court Apartment Homes",
  "property_seo_title_home": "Aspen Court Apartment Homes |  Apartments in Piscataway, NJ",
  "property_seo_description_home": "Experience modern living at Aspen Court in Piscataway, NJ! Spacious layouts, vibrant amenities, and a pet-friendly community await you!",
  "property_seo_title_floorplans": "Floor Plans | Piscataway, NJ Apartments for Rent",
  "property_seo_description_floorplans": "Find your perfect fit at Aspen Court Apartment Homes in Piscataway, NJ. Browse unique one and two-bedroom floor plans tailored for your lifestyle today!",
  "property_seo_title_amenities": "Amenities | Piscataway, NJ Apartments for Rent",
  "property_seo_description_amenities": "Experience unmatched comfort at Aspen Court in Piscataway, NJ! Enjoy a vibrant lifestyle with pet-friendly amenities, scenic trails, and stylish floor plans.",
  "property_seo_title_gallery": "Gallery | Apartments in Piscataway, NJ",
  "property_seo_description_gallery": "Picture life at Aspen Court in Piscataway, NJ. With stunning views and top-notch amenities like a pool, clubhouse, and serene trails, your new home awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Aspen Court Apartment Homes Apartments",
  "property_seo_description_virtualtours": "Step inside Aspen Court Apartment Homes in Piscataway, NJ! Take a virtual tour to find your perfect one or two-bedroom apartment today!",
  "property_seo_title_interactivemap": "Interactive Map | Aspen Court Apartment Homes Apartments",
  "property_seo_description_interactivemap": "Navigate your future at Aspen Court in Piscataway, NJ! Use our interactive map to find your ideal 1 or 2-bedroom apartment with top-tier amenities today!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Piscataway, NJ",
  "property_seo_description_neighborhood": "Uncover the charm of Piscataway from Aspen Court Apartment Homes. Experience vibrant local favorites and hidden gems just steps from your door!",
  "property_seo_title_contact": "Contact Us | Aspen Court Apartment Homes",
  "property_seo_description_contact": "Experience Aspen Court Apartment Homes in Piscataway, NJ. Inquire today about our spacious one and two-bedroom floor plans. Your new home awaits!",
  "property_seo_title_faqs": "FAQs | Apartments in Piscataway, NJ",
  "property_seo_description_faqs": "Uncover the answers you seek at Aspen Court Apartment Homes in Piscataway, NJ. Visit our FAQs for insights into life, rentals, and amenities tailored for you!",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Piscataway, NJ",
  "property_seo_description_reviews": "Discover resident reviews of Aspen Court Apartment Homes in Piscataway, NJ, and see why it's the ideal place to call home! Your adventure awaits!",
  "property_seo_title_applynow": "Apply Now | Apartments in Piscataway, NJ",
  "property_seo_description_applynow": "Experience the ideal blend of comfort and convenience at Aspen Court in Piscataway, NJ. Choose from versatile floor plans and enjoy top-notch amenities!",
  "property_seo_title_residentaccess": "Resident Access | Aspen Court Apartment Homes",
  "property_seo_description_residentaccess": "Unlock your Aspen Court experience! Log in to your resident portal for seamless rent payments, easy maintenance requests, and community updates in Piscataway.",
  "property_seo_title_referafriend": "Refer A Friend | Aspen Court Apartment Homes",
  "property_seo_description_referafriend": "Great friends make the best neighbors! Refer a friend to Aspen Court Apartment Homes in Piscataway and enjoy a vibrant community together.",
  "property_seo_title_scheduletour": "Schedule a Tour | Aspen Court Apartment Homes",
  "property_seo_description_scheduletour": "Experience the charm of Aspen Court in Piscataway, NJ. Schedule a tour today and envision your new home in our vibrant, welcoming community!",
  "property_seo_title_privacy": "Privacy Policy | Aspen Court Apartment Homes",
  "property_seo_description_privacy": "Your privacy matters at Aspen Court Apartment Homes. Review our comprehensive policy to see how we safeguard your data in beautiful Piscataway, NJ.",
  "property_seo_title_accessibility": "Website Accessibility | Aspen Court Apartment Homes",
  "property_seo_description_accessibility": "At Aspen Court Apartment Homes in Piscataway, NJ, we prioritize digital inclusivity. Join our community where accessibility meets comfort and convenience!",
  "property_seo_title_sitemap": "Sitemap | Aspen Court Apartment Homes",
  "property_seo_description_sitemap": "Uncover the layout of Aspen Court Apartment Homes in Piscataway, NJ. Navigate our sitemap to find your ideal space and embrace a vibrant lifestyle today!",
  "property_seo_title_thankyou": "Thank You | Aspen Court Apartment Homes",
  "property_seo_description_thankyou": "Thank you for reaching out to Aspen Court! Our team will be in touch soon to assist you in finding your ideal home in beautiful Piscataway, NJ.",
  "property_seo_title_pets": "Pet Policy | Apartments in Piscataway, NJ",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1792699240418",
  "amenities": [
    {
      "id": "custom_a576811a-6230-45f8-9fd3-580e6468c387",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c9eafc4a-def9-463e-b43a-ffdae771b6ad",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_3585c1db-b202-4c98-a4dd-a807f23fcce3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access Building",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4d48a505-349f-4a07-a89f-6975b625ffb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Fitness Center",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_e0835acf-a0e0-420d-ba65-c3615d847918",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Game Room",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_31982fd7-96a3-45b4-9ec8-aebe7366dfa7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Online Maintenance Requests",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_44de6522-c17b-41fa-8bcb-48f450f14b4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payment & Resident Portal",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_033686dc-072f-4049-9f23-382057286769",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_42922e38-f3fb-48e8-bcef-6df995d04f43",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dec739da-206f-48af-9b60-054abb0541db",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Pet Friendly",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_123a3904-077d-490a-9421-96bfc44cadb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Library",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b97aaa8a-c54d-4142-918e-1690021f703a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Short Term Leases",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a57254a6-24f6-4db1-9d8c-e51debcf576f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Air Conditioning",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_939aedaa-4217-4a8d-bcf1-6513c5315150",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Dens in Every Apartment",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_95eed09d-8963-479f-bb76-c695018fb224",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Hardwood Flooring*",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_74c9a14f-f936-4645-b7b3-11c19a911d21",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_21728b17-6343-4696-82fc-d28c6b0a92de",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Maple or White Cabinets",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_34a4187e-790c-46ad-8c39-a39de495dbb0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Microwave",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bf2765bc-1275-414a-bbbe-84047f9f4702",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Quartz & Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_992114c1-f2e7-496c-b5bc-d9c2536b93fe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bf42dfbc-7e9b-437a-b5b5-6011db3e0f4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Subway Tile Backsplash",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_47aaa78b-4169-4bf9-a031-af47ac2105cf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Washer & Dryer",
      "amount": "false",
      "description": "false",
      "group": "In-Home Features",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2c6246d3-6043-4d7d-bdd9-9892fcc817cd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Convenient Location Near I-287",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_dcf30ff4-ac6e-45dd-9333-a4e91119818f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Walking & Biking Trails",
      "amount": "false",
      "description": "false",
      "group": "Neighborhood",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_8a119eec-582c-4e09-b840-3de0a11f2758",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c74c564-8400-4a27-b4ed-bd4e282cb86f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "EV Charging Stations",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_efa344dc-064f-44dc-b99e-6f5b9a3aa000",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Free Resident and Guest Parking",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_add4105a-177d-4944-8148-5225ed7d24b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Grilling & Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bc4b817a-912e-4748-a9fc-ae51c6f1faa8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Outdoor Lounge with Firepit",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bea8cc58-2768-42c4-8ab8-c41b0a8fbdca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_319c906a-1fbf-4516-92ce-2e512337a481",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Swimming Pool",
      "amount": "false",
      "description": "false",
      "group": "Outdoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cdb93ceb-98d7-4bd0-b78f-4a5f5f40ed91",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "external_id": "false",
      "title": "Package Lockers",
      "amount": "false",
      "description": "false",
      "group": "Indoor Amenities",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_755530a2-fff4-48cb-8329-d587ac775db0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-7e85-775e-8aee-32c0d22d8d3d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with white cabinets, stainless steel appliances, and quartz countertops.",
        "public_id": "019fcdf2-7e85-775e-8aee-32c0d22d8d3d",
        "storage_key": "property/6767906449166309/019fcdf2-7e85-775e-8aee-32c0d22d8d3d.webp",
        "width": 2000,
        "height": 1329
      },
      "title": "Apartment",
      "description": "Stunning modern kitchen featuring sleek white cabinetry, durable quartz countertops, and a full suite of stainless steel appliances, perfect for any home chef.",
      "link": "false",
      "alt_text": "Modern white kitchen with stainless-steel appliances and marble countertops.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/58c60499b807c7d8a060de7a74acb6be.webp"
    },
    {
      "id": "custom_2bf54a4d-a8f4-43fb-80fd-cbeb556c9adf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-7dd8-76e9-8394-fc395930d83b.webp",
      "image_media": {
        "alt_text": "Living room with a couch, coffee table, TV, and a balcony door.",
        "public_id": "019fcdf2-7dd8-76e9-8394-fc395930d83b",
        "storage_key": "property/6767906449166309/019fcdf2-7dd8-76e9-8394-fc395930d83b.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Spacious living area featuring a comfortable couch, modern entertainment center, and access to a private balcony with scenic views.",
      "link": "false",
      "alt_text": "Living room in an apartment with a sofa, TV on a wooden credenza, and a glass sliding door to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/42014975eecc6522e49c893312c218f7.jpg"
    },
    {
      "id": "custom_0c12d9aa-a654-4cd9-9713-3f32a843dfad",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-7ee8-7026-8f4a-0a32afa4f81a.webp",
      "image_media": {
        "alt_text": "Spacious living room with a sectional sofa, coffee table, TV, and balcony access.",
        "public_id": "019fcdf2-7ee8-7026-8f4a-0a32afa4f81a",
        "storage_key": "property/6767906449166309/019fcdf2-7ee8-7026-8f4a-0a32afa4f81a.webp",
        "width": 2000,
        "height": 1331
      },
      "title": "Apartment",
      "description": "A spacious, contemporary living area with neutral tones, a TV on a console, and sliding balcony doors.",
      "link": "false",
      "alt_text": "Bright living room in a modern apartment with a sofa, TV, and glass balcony doors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/3ea173bf3318a2a5faf934eae8fe26fc.webp"
    },
    {
      "id": "custom_b8aae8a1-9858-4cd5-adb8-82caea9da903",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-7ee6-736f-ab07-5651ba856fd4.webp",
      "image_media": {
        "alt_text": "Spacious bedroom with a large bed, nightstands, and artwork. An en-suite bathroom is visible through an open doorway.",
        "public_id": "019fcdf2-7ee6-736f-ab07-5651ba856fd4",
        "storage_key": "property/6767906449166309/019fcdf2-7ee6-736f-ab07-5651ba856fd4.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Relax and unwind in the comfortable bedroom, featuring plush bedding and elegant decor. The adjacent en-suite bathroom offers convenience and privacy.",
      "link": "false",
      "alt_text": "Spacious bedroom with a large bed, nightstands, and artwork. An en-suite bathroom is visible through an open doorway.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/Property_EED9_DSC_2788_19-09-25_11_18.jpg"
    },
    {
      "id": "custom_e947b0ad-1d0b-4692-921f-eca5e265764d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-89a5-70fd-9d50-585b0eaa13e9.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, tufted headboard, and decorative pillows.",
        "public_id": "019fcdf2-89a5-70fd-9d50-585b0eaa13e9",
        "storage_key": "property/6767906449166309/019fcdf2-89a5-70fd-9d50-585b0eaa13e9.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Bright bedroom in a contemporary apartment with a tufted headboard, blue accents, and built-in shelving for decor.",
      "link": "false",
      "alt_text": "Bedroom in a modern apartment with a tufted headboard, blue bedding, and a white bookshelf.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/f8e0425ccf0c4b2d59b60a76333ffd9c.jpg"
    },
    {
      "id": "custom_25709073-7b55-4d42-b4c5-1e468e138bc0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-8ac8-73bd-a0ff-7237a7e70dd4.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a large bed, bedside tables, and a window overlooking the neighborhood.",
        "public_id": "019fcdf2-8ac8-73bd-a0ff-7237a7e70dd4",
        "storage_key": "property/6767906449166309/019fcdf2-8ac8-73bd-a0ff-7237a7e70dd4.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Relax in comfort in this spacious bedroom, featuring a plush queen-sized bed and ample natural light from the large window.",
      "link": "false",
      "alt_text": "Bedroom in an apartment with a neatly made bed, two nightstands, lamps, and wall art.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/8241868b5bd271ec693f040925b57088.jpg"
    },
    {
      "id": "custom_6ac54707-5bf6-49cc-bc73-eac95bafcd5b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-8c8a-7550-9f24-efeb3f779cc4.webp",
      "image_media": {
        "alt_text": "Living room with a sectional sofa, coffee table, and large window.",
        "public_id": "019fcdf2-8c8a-7550-9f24-efeb3f779cc4",
        "storage_key": "property/6767906449166309/019fcdf2-8c8a-7550-9f24-efeb3f779cc4.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Apartment",
      "description": "Modern apartment living room with neutral tones, cozy seating, and balcony access.",
      "link": "false",
      "alt_text": "Bright living room with a beige sectional, round coffee table, and sliding glass door to a balcony.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/b0a2154a020d7d498386a5275c0dcc48.webp"
    },
    {
      "id": "custom_f7e062f3-1b8f-4a53-a295-a395adcac390",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-8ce3-7489-8b35-3f96be82095b.webp",
      "image_media": {
        "alt_text": "Primary bedroom with a king-size bed, dresser, and wall-mounted TV.",
        "public_id": "019fcdf2-8ce3-7489-8b35-3f96be82095b",
        "storage_key": "property/6767906449166309/019fcdf2-8ce3-7489-8b35-3f96be82095b.webp",
        "width": 1280,
        "height": 854
      },
      "title": "Apartment",
      "description": "A modern apartment bedroom featuring a plush bed, matching dresser, and a large window for natural light.",
      "link": "false",
      "alt_text": "Modern apartment bedroom with a bed, dresser, plant, and a large window.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/cb9a93b750ed838f7f5c9feade881897.webp"
    },
    {
      "id": "custom_c7c3262b-42cf-4d0d-9be2-390679fd0383",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-941f-74ac-a429-dd8f5f2a78f0.webp",
      "image_media": {
        "alt_text": "Balcony view of the community amenities including a pool, playground, and parking lot.",
        "public_id": "019fcdf2-941f-74ac-a429-dd8f5f2a78f0",
        "storage_key": "property/6767906449166309/019fcdf2-941f-74ac-a429-dd8f5f2a78f0.webp",
        "width": 1920,
        "height": 1278
      },
      "title": "Apartment",
      "description": "Enjoy your morning coffee or evening tea on your private balcony, overlooking the resort-style pool, playground, and the community grounds.",
      "link": "false",
      "alt_text": "Private balcony with wicker chairs and hanging plant, overlooking a landscaped apartment community.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/24a6cf7b65f189be57133d6ce9d099e3.jpg"
    },
    {
      "id": "custom_11834ae9-b2dc-45e0-9e62-6ca91d5ad888",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-9533-7209-b97d-154062b88a49.webp",
      "image_media": {
        "alt_text": "Laundry room with washer, dryer, and shelving.",
        "public_id": "019fcdf2-9533-7209-b97d-154062b88a49",
        "storage_key": "property/6767906449166309/019fcdf2-9533-7209-b97d-154062b88a49.webp",
        "width": 2000,
        "height": 1331
      },
      "title": "Apartment",
      "description": "In-unit laundry area with a washer, a dryer, and adjustable white wire shelving for storage.",
      "link": "false",
      "alt_text": "Laundry room with a washer and dryer and white wire shelving along the walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/92ced8a877a173a787c2e5a18df2a2bf.webp"
    },
    {
      "id": "custom_73afc5bf-e54a-4ee8-8e6c-0fc2295e2175",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-966a-71eb-9ca2-8d3a0298981b.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with double sinks, mirrors, and a walk-in shower.",
        "public_id": "019fcdf2-966a-71eb-9ca2-8d3a0298981b",
        "storage_key": "property/6767906449166309/019fcdf2-966a-71eb-9ca2-8d3a0298981b.webp",
        "width": 2000,
        "height": 1331
      },
      "title": "Apartment",
      "description": "Contemporary apartment bathroom with a white double vanity, marble countertop, and glass-enclosed shower.",
      "link": "false",
      "alt_text": "Bathroom with a white double vanity, two framed mirrors, a window, and a glass-enclosed shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/f26034b25e64a84a5d0cf13ac2289f72.webp"
    },
    {
      "id": "custom_003dabef-db53-4eb1-bf29-6907cd4bb6d9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-9809-756c-842d-4b3755c8d967.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a white vanity, marble countertop, and a large mirror.",
        "public_id": "019fcdf2-9809-756c-842d-4b3755c8d967",
        "storage_key": "property/6767906449166309/019fcdf2-9809-756c-842d-4b3755c8d967.webp",
        "width": 2000,
        "height": 1331
      },
      "title": "Apartment",
      "description": "Bright apartment bathroom featuring a white vanity, beige tile surround, and a toilet with neatly rolled towels.",
      "link": "false",
      "alt_text": "Modern apartment bathroom with beige tile tub/shower surround, black shower curtain, white vanity, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/6977db465813d56f0e6fac56a5d73f95.webp"
    },
    {
      "id": "custom_e9cd2bd0-2720-416d-8450-236c1425ba6d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-9e96-726c-88c3-ec8646d7732d.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and medicine cabinet.",
        "public_id": "019fcdf2-9e96-726c-88c3-ec8646d7732d",
        "storage_key": "property/6767906449166309/019fcdf2-9e96-726c-88c3-ec8646d7732d.webp",
        "width": 2000,
        "height": 1331
      },
      "title": "Apartment",
      "description": "Modern apartment bathroom with white vanity, marble countertop, wall mirror, and toilet.",
      "link": "false",
      "alt_text": "Bright apartment bathroom with a white vanity, sink, mirror, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/d187bede9dbd5fe78be2579aeef98f60.webp"
    },
    {
      "id": "custom_002545c1-7c71-4d4b-9387-dc181c4926c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-9ff0-746f-a17b-501a8e7388df.webp",
      "image_media": {
        "alt_text": "A fenced-in dog park with agility equipment, including a tunnel, ramps, and a bench.",
        "public_id": "019fcdf2-9ff0-746f-a17b-501a8e7388df",
        "storage_key": "property/6767906449166309/019fcdf2-9ff0-746f-a17b-501a8e7388df.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Enjoy our community dog park, complete with agility equipment for your furry friends to play and socialize.",
      "link": "false",
      "alt_text": "Playground in an apartment community with a slide, climbing structure, and grassy field.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/0d8447f09806976df1f9596e1bcf1785.webp"
    },
    {
      "id": "custom_29ac604d-00c8-4edd-9efd-186a04eaa622",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-a286-71ef-b49f-d503130e23c5.webp",
      "image_media": {
        "alt_text": "Playground with slides and swings in front of apartment buildings.",
        "public_id": "019fcdf2-a286-71ef-b49f-d503130e23c5",
        "storage_key": "property/6767906449166309/019fcdf2-a286-71ef-b49f-d503130e23c5.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "A family-friendly community playground with slides and swings set against modern apartment buildings.",
      "link": "false",
      "alt_text": "Green playground with a slide, climbing structures and swings in a courtyard of apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/bfe708f8c131ce2a97bc35fa77484b13.webp"
    },
    {
      "id": "custom_1b651667-ffd8-4f4f-a6f9-38d7c27144c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-a51b-7338-ac06-38de710ac4b4.webp",
      "image_media": {
        "alt_text": "Large outdoor swimming pool with lounge chairs and umbrellas in front of apartment buildings.",
        "public_id": "019fcdf2-a51b-7338-ac06-38de710ac4b4",
        "storage_key": "property/6767906449166309/019fcdf2-a51b-7338-ac06-38de710ac4b4.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Outdoor pool area at a residential community, with lounge chairs, orange umbrellas, and surrounding apartment buildings.",
      "link": "false",
      "alt_text": "Outdoor pool at a residential community with lounge chairs and orange umbrellas.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/c8fc8b340fedc1b1c2d26df3c38803c1.jpg"
    },
    {
      "id": "custom_b82b6a4b-f586-40f1-8e13-b900b5b80afc",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-ab6b-77dc-aedd-683e0f7cb281.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and umbrellas, surrounded by apartment buildings.",
        "public_id": "019fcdf2-ab6b-77dc-aedd-683e0f7cb281",
        "storage_key": "property/6767906449166309/019fcdf2-ab6b-77dc-aedd-683e0f7cb281.webp",
        "width": 1280,
        "height": 853
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, complete with comfortable lounge chairs and umbrellas for ultimate relaxation. A perfect oasis for residents to unwind and soak up the sun.",
      "link": "false",
      "alt_text": "Outdoor community pool with lounge chairs and orange umbrellas, surrounded by apartment buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/fa25b7d0a8f24168316350e02e23bc22.jpg"
    },
    {
      "id": "custom_9ad8e382-8328-4250-a1ff-b1e239d4ad83",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-ad0a-72a5-bb18-e939bfba06d7.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills and weight machines.",
        "public_id": "019fcdf2-ad0a-72a5-bb18-e939bfba06d7",
        "storage_key": "property/6767906449166309/019fcdf2-ad0a-72a5-bb18-e939bfba06d7.webp",
        "width": 2000,
        "height": 1332
      },
      "title": "Community",
      "description": "Well-equipped resident gym featuring cardio machines and strength equipment for on-site workouts.",
      "link": "false",
      "alt_text": "Bright orange-walled community gym with treadmills, elliptical, and weight machines.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/ed632de5e536b4de82e4138e95f53eb0.webp"
    },
    {
      "id": "custom_2988e73b-4cdf-4e53-beb6-2d08fe7b1141",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-aebe-729f-b594-3606b7a28f87.webp",
      "image_media": {
        "alt_text": "Outdoor patio area with dining tables, umbrellas, and built-in grills.",
        "public_id": "019fcdf2-aebe-729f-b594-3606b7a28f87",
        "storage_key": "property/6767906449166309/019fcdf2-aebe-729f-b594-3606b7a28f87.webp",
        "width": 2000,
        "height": 1332
      },
      "title": "Community",
      "description": "Shared outdoor amenity with seating, orange umbrellas, string lights, a grill, and landscaped gravel gathering spaces for residents.",
      "link": "false",
      "alt_text": "Outdoor community courtyard with orange umbrellas, string lights, gravel ground, and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/fba97a2bdabb6df35de9af1bfb4a6bfa.webp"
    },
    {
      "id": "custom_3f90fcde-37dc-4e26-aa3f-7a353dad7b62",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-b16a-747b-83bf-3f0af10a3a81.webp",
      "image_media": {
        "alt_text": "Playground equipment with slides and swings in front of apartment buildings.",
        "public_id": "019fcdf2-b16a-747b-83bf-3f0af10a3a81",
        "storage_key": "property/6767906449166309/019fcdf2-b16a-747b-83bf-3f0af10a3a81.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "Outdoor playground at a multifamily community with a tan slide, green-framed equipment, and surrounding residential buildings.",
      "link": "false",
      "alt_text": "Playground with slides and climbing structure in a residential community courtyard.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/1aaab1305a9801b82b048bc6148c3925.jpg"
    },
    {
      "id": "custom_4e838c9f-d925-4a3b-9c23-b8339603b23e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-b6e0-71a1-ad03-34535e61a3c8.webp",
      "image_media": {
        "alt_text": "Outdoor fire pit area with orange Adirondack chairs and string lights.",
        "public_id": "019fcdf2-b6e0-71a1-ad03-34535e61a3c8",
        "storage_key": "property/6767906449166309/019fcdf2-b6e0-71a1-ad03-34535e61a3c8.webp",
        "width": 2000,
        "height": 1332
      },
      "title": "Community",
      "description": "Gather around the fire pit and enjoy the evening with friends in this cozy outdoor seating area, complete with comfortable chairs and ambient string lights.",
      "link": "false",
      "alt_text": "Outdoor community courtyard with orange Adirondack chairs around a fire pit and string lights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/81c33d2f8b74a96bf1e5c31444f3ded2.webp"
    },
    {
      "id": "custom_0f0ebc10-befd-4e0d-a2d3-46069228f2cb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-b8d2-73b9-ae09-9f134f17d6a9.webp",
      "image_media": {
        "alt_text": "Outdoor seating area with tables and chairs under a pergola.",
        "public_id": "019fcdf2-b8d2-73b9-ae09-9f134f17d6a9",
        "storage_key": "property/6767906449166309/019fcdf2-b8d2-73b9-ae09-9f134f17d6a9.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Shared outdoor space for residents featuring shaded seating under pergolas and inviting tables.",
      "link": "false",
      "alt_text": "Outdoor community lounge with metal pergolas, string lights, and patio seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/93ecae0e6d53ad981cb452c41b411c8f.webp"
    },
    {
      "id": "custom_7cf71101-c29e-405d-9a32-9e49eeac842c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-bcca-754c-982a-fa3ecfcf22ab.webp",
      "image_media": {
        "alt_text": "Interior of a fitness center with weight machines, free weights, and benches.",
        "public_id": "019fcdf2-bcca-754c-982a-fa3ecfcf22ab",
        "storage_key": "property/6767906449166309/019fcdf2-bcca-754c-982a-fa3ecfcf22ab.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Modern resident fitness center featuring weight machines, free weights, and benches in a communal amenity space.",
      "link": "false",
      "alt_text": "Well-lit indoor fitness center with weight machines, benches, and free weights.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/15cb6f3bea8b7bec83457011d4aafa86.jpg"
    },
    {
      "id": "custom_3f413300-fb3f-4602-9cf8-d61448633629",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-bd5a-730a-b0b6-7029e5d1556d.webp",
      "image_media": {
        "alt_text": "Fitness center with cardio machines, weight training equipment, and an orange accent wall.",
        "public_id": "019fcdf2-bd5a-730a-b0b6-7029e5d1556d",
        "storage_key": "property/6767906449166309/019fcdf2-bd5a-730a-b0b6-7029e5d1556d.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "State-of-the-art fitness center featuring cardio machines like treadmills and ellipticals, as well as weight training equipment for a complete workout.",
      "link": "false",
      "alt_text": "Fitness center with cardio machines, weight station, and bright orange wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/ac46db2e11faa88b53f792b6c5adc9ed.webp"
    },
    {
      "id": "custom_b031d605-f9fd-4bd6-84a8-86cdbce512ba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-c4fc-744f-85b2-e01dba74b923.webp",
      "image_media": {
        "alt_text": "Community lounge area with a pool table and shuffleboard.",
        "public_id": "019fcdf2-c4fc-744f-85b2-e01dba74b923",
        "storage_key": "property/6767906449166309/019fcdf2-c4fc-744f-85b2-e01dba74b923.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "A modern community lounge with a pool table, bar seating, and cozy seating areas.",
      "link": "false",
      "alt_text": "Indoor resident lounge with a pool table, bar-height tables, and a wall-mounted TV.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/39882cd5af180a8f9c7d832003a82419.jpg"
    },
    {
      "id": "custom_34f4dbc1-2afc-48a2-9c66-e9e7319f4047",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-c772-77cc-8c98-fa6ca98d9be3.webp",
      "image_media": {
        "alt_text": "Spacious community lounge with modern seating, wood accents, and large windows.",
        "public_id": "019fcdf2-c772-77cc-8c98-fa6ca98d9be3",
        "storage_key": "property/6767906449166309/019fcdf2-c772-77cc-8c98-fa6ca98d9be3.webp",
        "width": 2000,
        "height": 1332
      },
      "title": "Community",
      "description": "Modern resident lounge with comfortable seating, large windows, and a high communal table for socializing.",
      "link": "false",
      "alt_text": "Interior community lounge with blue ceiling, wood accent wall, and assorted seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/737c062aa5356fc1811d97b426a43c28.webp"
    },
    {
      "id": "custom_171a3447-eb1a-472a-8c57-2904f8646d44",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-c831-72e1-b186-03d78e0fd96e.webp",
      "image_media": {
        "alt_text": "Modern lounge area with dark blue sectional sofa, accent chairs, marble coffee table, and business center.",
        "public_id": "019fcdf2-c831-72e1-b186-03d78e0fd96e",
        "storage_key": "property/6767906449166309/019fcdf2-c831-72e1-b186-03d78e0fd96e.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "Relax and work in our stylish community lounge, featuring comfortable seating, a business center with computers, and a modern aesthetic.",
      "link": "false",
      "alt_text": "Interior community lounge with blue walls, modern seating, and a desk area with computers.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/d07dc12bd6539a294643467019037a86.jpg"
    },
    {
      "id": "custom_093815a1-5d0d-4af6-914c-183675fb4e17",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-c97f-7574-a6db-24d10dca4c89.webp",
      "image_media": {
        "alt_text": "Clubhouse with pool table and lounge area with seating and TV.",
        "public_id": "019fcdf2-c97f-7574-a6db-24d10dca4c89",
        "storage_key": "property/6767906449166309/019fcdf2-c97f-7574-a6db-24d10dca4c89.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "A modern resident lounge in a multifamily community with TV, seating, tables, and a game area.",
      "link": "false",
      "alt_text": "Interior community lounge with dark walls, windows, TV, and seating.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/193e1b00984fdd523ede84904f5bba2a.webp"
    },
    {
      "id": "custom_a9aeb486-24e0-4754-863d-efc728758d2a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-d056-71c4-96e5-9475078e7f2c.webp",
      "image_media": {
        "alt_text": "Apartment complex exterior with an outdoor seating area with Adirondack chairs and a fire pit.",
        "public_id": "019fcdf2-d056-71c4-96e5-9475078e7f2c",
        "storage_key": "property/6767906449166309/019fcdf2-d056-71c4-96e5-9475078e7f2c.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "Outdoor resident gathering space with a fire pit and orange chairs by apartment buildings.",
      "link": "false",
      "alt_text": "Outdoor community courtyard with a fire pit and orange chairs in front of apartment buildings",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/1f6fd1392a09a8a2ece85653186c941c.jpg"
    },
    {
      "id": "custom_686fd094-2240-42bd-9074-1fc77c54647b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-d32d-7129-89f0-55b5f1c4d2cc.webp",
      "image_media": {
        "alt_text": "Modern lounge area with blue banquette seating, wood paneled walls, and decorative mirrors.",
        "public_id": "019fcdf2-d32d-7129-89f0-55b5f1c4d2cc",
        "storage_key": "property/6767906449166309/019fcdf2-d32d-7129-89f0-55b5f1c4d2cc.webp",
        "width": 1920,
        "height": 1281
      },
      "title": "Community",
      "description": "Relax in the stylish community lounge, featuring comfortable seating, modern decor, and ample space for residents to socialize or unwind.",
      "link": "false",
      "alt_text": "Interior resident lounge with blue seating, round tables, arched mirrors, and wood-paneled walls.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/b529297c22cfbb0c0da9bbfef316c7da.jpg"
    },
    {
      "id": "custom_e5630296-2895-489d-ae2f-d9faa8ed1b4d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-d435-711f-92bd-a739e2d3929c.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with balconies and parking lot.",
        "public_id": "019fcdf2-d435-711f-92bd-a739e2d3929c",
        "storage_key": "property/6767906449166309/019fcdf2-d435-711f-92bd-a739e2d3929c.webp",
        "width": 1920,
        "height": 1280
      },
      "title": "Community",
      "description": "Beautiful apartment buildings with well-maintained landscaping and ample parking.",
      "link": "false",
      "alt_text": "Exterior view of a multi-building apartment complex with balconies under a blue sky.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/d7ac898973da9f430314e821dd91a569.jpg"
    },
    {
      "id": "custom_1509f5fb-dd89-477d-9a1a-61ed70f7c0ee",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-de61-756a-a76f-4395e89dd373.webp",
      "image_media": {
        "alt_text": "Apartment complex with playground and gazebo",
        "public_id": "019fcdf2-de61-756a-a76f-4395e89dd373",
        "storage_key": "property/6767906449166309/019fcdf2-de61-756a-a76f-4395e89dd373.webp",
        "width": 1136,
        "height": 639
      },
      "title": "Community",
      "description": "Aerial view of a modern apartment community featuring green spaces, walking paths, a central playground, and a gazebo.",
      "link": "false",
      "alt_text": "Aerial view of a multi-building apartment community with a playground, gazebo, and green lawns.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/29bd61e03501bcd23155f7611318b60b.webp"
    },
    {
      "id": "custom_994735fc-1194-4318-8f00-8e4f0e5ef15c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-e1fa-7108-a30d-9d8f5e3614e5.webp",
      "image_media": {
        "alt_text": "Apartment community with a gazebo, playground, and apartment buildings under a clear blue sky.",
        "public_id": "019fcdf2-e1fa-7108-a30d-9d8f5e3614e5",
        "storage_key": "property/6767906449166309/019fcdf2-e1fa-7108-a30d-9d8f5e3614e5.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "A spacious apartment community with a white gazebo, green lawns, benches, and a playground.",
      "link": "false",
      "alt_text": "White gazebo in a green apartment courtyard with a playground and multi-story buildings.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/18bce181680e7fa9f45208c72b303e9b.jpg"
    },
    {
      "id": "custom_ccd0ce91-0302-40f7-b6e9-7ee8f48e4469",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-e35b-746d-86e8-f84b4fcdb964.webp",
      "image_media": {
        "alt_text": "Exterior view of Aspen Court apartment buildings with manicured lawns and trees.",
        "public_id": "019fcdf2-e35b-746d-86e8-f84b4fcdb964",
        "storage_key": "property/6767906449166309/019fcdf2-e35b-746d-86e8-f84b4fcdb964.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "Aerial view of the Aspen Court community showcasing its apartment buildings, green spaces, and surrounding natural beauty under a clear blue sky.",
      "link": "false",
      "alt_text": "Aerial view of a large apartment community with multiple buildings, green lawns, and parking lots.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/5f165f9d1813a4c72e5a3364eda511f3.jpg"
    },
    {
      "id": "custom_d39e3810-2b7c-4931-8478-431b6508a2b9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-eb66-76fd-8143-90aca9070289.webp",
      "image_media": {
        "alt_text": "Exterior of a multifamily apartment building with a parking lot in the foreground.",
        "public_id": "019fcdf2-eb66-76fd-8143-90aca9070289",
        "storage_key": "property/6767906449166309/019fcdf2-eb66-76fd-8143-90aca9070289.webp",
        "width": 2048,
        "height": 1366
      },
      "title": "Community",
      "description": "Exterior view of a modern apartment community with well-kept landscaping and ample parking.",
      "link": "false",
      "alt_text": "Exterior view of a multi-story apartment building with brick base, beige siding, and a surrounding parking lot.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/6e9c83cacf9b7025abea2779db884bd3.webp"
    },
    {
      "id": "custom_dd82ef6f-4b17-4fdb-9e14-544c2fc9adba",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-ef03-748d-bf21-90b3fe0fee35.webp",
      "image_media": {
        "alt_text": "Aerial view of a sprawling apartment complex with multiple buildings and parking lots, surrounded by trees and a large grassy field.",
        "public_id": "019fcdf2-ef03-748d-bf21-90b3fe0fee35",
        "storage_key": "property/6767906449166309/019fcdf2-ef03-748d-bf21-90b3fe0fee35.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "Bird's-eye view of a sprawling apartment complex with multiple buildings, parking, and surrounding open space.",
      "link": "false",
      "alt_text": "Aerial view of a large apartment community with rows of buildings, roads, and green spaces.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/88a9c33d4e1f2d865dcf815a5a8cbc1b.jpg"
    },
    {
      "id": "custom_084cd6fe-b9d0-418f-af76-add18a2ee173",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-ef9b-72ce-85dd-703825a9e37c.webp",
      "image_media": {
        "alt_text": "Aerial view of apartment complex featuring a swimming pool, playground, and community courtyard.",
        "public_id": "019fcdf2-ef9b-72ce-85dd-703825a9e37c",
        "storage_key": "property/6767906449166309/019fcdf2-ef9b-72ce-85dd-703825a9e37c.webp",
        "width": 1920,
        "height": 1279
      },
      "title": "Community",
      "description": "Bird's-eye view of a residential community’s central courtyard, pool, and walkways amid surrounding buildings.",
      "link": "false",
      "alt_text": "Aerial view of a multi-building apartment complex courtyard with a pool.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/d83918bb3e8ec12ba044ed68cafb7473.jpg"
    },
    {
      "id": "custom_32966980-cace-46f0-8037-1bc90bac6bfa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf2-f0e7-74b8-81fc-dcb710ae92ee.webp",
      "image_media": {
        "alt_text": "Aerial view of a luxury apartment complex with a swimming pool, outdoor seating areas, and well-maintained landscaping.",
        "public_id": "019fcdf2-f0e7-74b8-81fc-dcb710ae92ee",
        "storage_key": "property/6767906449166309/019fcdf2-f0e7-74b8-81fc-dcb710ae92ee.webp",
        "width": 2000,
        "height": 1332
      },
      "title": "Community",
      "description": "Bird's-eye view of a modern apartment community featuring a pool, clubhouse, pergolas, and winding walkways through landscaped grounds.",
      "link": "false",
      "alt_text": "Aerial view of a residential apartment community with a pool, clubhouse, and landscaped courtyards.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://irp.cdn-website.com/5a7473c7/dms3rep/multi/5767906449162442/6767906449166309/62770d5c3f852200c24ef54497ca3164.webp"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_6aa02c9d-5790-49bc-9bf6-378422908dd2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Panera Bread",
      "poi_type": "Restaurants",
      "poi_address": "1333 Centennial Ave, Piscataway, NJ 08854, USA",
      "poi_short_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_long_description": "Counter-serve bakery/cafe chain serving sandwiches, salads & more, known for its bread & free WiFi.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019ffbbf-4a5c-71a3-b1d3-b643bdb5a41f.webp",
      "poi_featured_image_media": {
        "alt_text": "Display case filled with a variety of baked goods including croissants, pastries, and cakes.",
        "public_id": "019ffbbf-4a5c-71a3-b1d3-b643bdb5a41f",
        "storage_key": "property/6767906449166309/019ffbbf-4a5c-71a3-b1d3-b643bdb5a41f.webp",
        "width": 731,
        "height": 1300
      },
      "poi_business_url": "https://www.panerabread.com/en-us/cafe/locations/nj/piscataway/1333-centennial-ave?utm_medium=local&utm_source=google&utm_campaign=dpm-dist&utm_term=601492&utm_content=main",
      "poi_directions_map_url": "https://maps.google.com/?cid=4932644417916573116&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panera-bread",
      "poi_latitude": "40.5535419",
      "poi_longitude": "-74.4385336",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 732-981-8221",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4dee-7465-b74f-36e3d3a25d75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4dee-7465-b74f-36e3d3a25d75",
        "storage_key": "property/6767906449166309/019d0266-4dee-7465-b74f-36e3d3a25d75.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJM3uRpG-4w4kRvBU7vfZFdEQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d83142e3-7052-4eb5-bae1-1a1afb7e1650",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "LongHorn Steakhouse",
      "poi_type": "Restaurants",
      "poi_address": "1368 Centennial Ave, Piscataway, NJ 08854, USA",
      "poi_short_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_long_description": "Casual steakhouse chain known for grilled beef & other American dishes in a ranch-style space.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-059e-706c-97fd-14c05598bb0d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-059e-706c-97fd-14c05598bb0d",
        "storage_key": "property/6767906449166309/019fcdf3-059e-706c-97fd-14c05598bb0d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.longhornsteakhouse.com/locations/nj/piscataway/piscataway/5185?cmpid=br:lh_ag:ie_ch:loc_ca:LHGMB_sn:gmb_gt:piscataway-nj-5185_pl:locurl_rd:1141",
      "poi_directions_map_url": "https://maps.google.com/?cid=10049497735141246036&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "longhorn-steakhouse",
      "poi_latitude": "40.551649",
      "poi_longitude": "-74.43554999999999",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 732-981-8200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4d3c-7308-bd13-aeb63e21d0f8",
        "storage_key": "property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4VO9D264w4kRVMQvEvL8dos",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_db622e4c-2f5d-463c-b625-f0e134039d67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "1317 Centennial Ave, Piscataway, NJ 08854, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-0543-704b-9ead-713a047cdf39.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-0543-704b-9ead-713a047cdf39",
        "storage_key": "property/6767906449166309/019fcdf3-0543-704b-9ead-713a047cdf39.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olivegarden.com/locations/nj/piscataway/piscataway-centenial-square/1809?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:piscataway-nj-1809_pl:locurl_rd:1654",
      "poi_directions_map_url": "https://maps.google.com/?cid=4150475858882728582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "40.5529",
      "poi_longitude": "-74.44069999999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 732-562-0142",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4d3c-7308-bd13-aeb63e21d0f8",
        "storage_key": "property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJE7tMWGW4w4kRhhKKsc1zmTk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1d977dc3-61f0-4f67-8646-cb07e69f4650",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Midori Sushi of Piscataway",
      "poi_type": "Restaurants",
      "poi_address": "1392 Centennial Ave, Piscataway, NJ 08854, USA",
      "poi_short_description": "Japanese eatery serves unique sushi rolls, teriyaki & hibachi in a classy, subdued room.",
      "poi_long_description": "Japanese eatery serves unique sushi rolls, teriyaki & hibachi in a classy, subdued room.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-05f5-76ab-a127-2f4ca8b5e8d1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-05f5-76ab-a127-2f4ca8b5e8d1",
        "storage_key": "property/6767906449166309/019fcdf3-05f5-76ab-a127-2f4ca8b5e8d1.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://order.mealkeyway.com/customer/release/index?mid=303933315145346d694c416e732b564b4954304772513d3d#/main",
      "poi_directions_map_url": "https://maps.google.com/?cid=8215425776164390454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "midori-sushi-of-piscataway",
      "poi_latitude": "40.5513155",
      "poi_longitude": "-74.4347628",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 732-981-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4d3c-7308-bd13-aeb63e21d0f8",
        "storage_key": "property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJWdqXF264w4kRNsbdWjcOA3I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c4b79be9-3567-4140-89bb-9f1f8b7fc1da",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Gabriele's Bar & Grill",
      "poi_type": "Restaurants",
      "poi_address": "1351 Centennial Ave, Piscataway, NJ 08854, USA",
      "poi_short_description": "Local tavern with menu of American & Italian classics, plus games including pool, darts & bowling.",
      "poi_long_description": "Local tavern with menu of American & Italian classics, plus games including pool, darts & bowling.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-0b83-7638-83a9-ae93dc082898.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-0b83-7638-83a9-ae93dc082898",
        "storage_key": "property/6767906449166309/019fcdf3-0b83-7638-83a9-ae93dc082898.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gabrielesbarandgrill.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11246706402376749731&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gabrieles-bar--grill",
      "poi_latitude": "40.5530749",
      "poi_longitude": "-74.4350219",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 732-981-1234",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5858-70a0-a450-d0908ede06f5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5858-70a0-a450-d0908ede06f5",
        "storage_key": "property/6767906449166309/019d0266-5858-70a0-a450-d0908ede06f5.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJk_UG1m24w4kRoxLHpuJTFJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_740eff2d-1b6c-45e1-a16f-aee7266271f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Otto's Pizza & Pasta",
      "poi_type": "Restaurants",
      "poi_address": "620 Clinton Ave, Piscataway, NJ 08854, USA",
      "poi_short_description": "Cozy family-run pizzeria offering a variety of pies, plus subs, wings, and pasta dishes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-0c81-76eb-928d-e0d1d77c3392.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-0c81-76eb-928d-e0d1d77c3392",
        "storage_key": "property/6767906449166309/019fcdf3-0c81-76eb-928d-e0d1d77c3392.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://ottospizzanj.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9777090597605586357&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ottos-pizza--pasta",
      "poi_latitude": "40.5971504",
      "poi_longitude": "-74.4380515",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 908-205-0916",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4d3c-7308-bd13-aeb63e21d0f8",
        "storage_key": "property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJm5BIHHC5w4kRtbUX5xg0r4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4cf8d084-3aed-4ad9-8f8f-e10909b497b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Chand Palace - Vegetarian Cuisine of India",
      "poi_type": "Restaurants",
      "poi_address": "1296 Centennial Ave, Piscataway, NJ 08854, USA",
      "poi_short_description": "Vegetarian North & South Indian eats (from mild to spicy) offered buffet-style in simple digs.",
      "poi_long_description": "Vegetarian North & South Indian eats (from mild to spicy) offered buffet-style in simple digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-0c19-72fb-837b-598fc5d28076.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-0c19-72fb-837b-598fc5d28076",
        "storage_key": "property/6767906449166309/019fcdf3-0c19-72fb-837b-598fc5d28076.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.chandpalacepiscataway.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9283561393347859618&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "chand-palace---vegetarian-cuisine-of-india",
      "poi_latitude": "40.5514807",
      "poi_longitude": "-74.44343760000001",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 732-465-1474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4d3c-7308-bd13-aeb63e21d0f8",
        "storage_key": "property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJB-Y4tGS4w4kRopQHnebV1YA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_268c5ac7-6245-41d9-aac6-d0d8d9371eec",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "QDOBA Mexican Eats",
      "poi_type": "Restaurants",
      "poi_address": "604 Bartholomew Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "A menu of customizable Mexican food served in a modern restaurant, plus takeout & catering.",
      "poi_long_description": "A menu of customizable Mexican food served in a modern restaurant, plus takeout & catering.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-0c7b-707d-943f-63e9784b60d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-0c7b-707d-943f-63e9784b60d9",
        "storage_key": "property/6767906449166309/019fcdf3-0c7b-707d-943f-63e9784b60d9.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.qdoba.com/locations?utm_medium=organic&utm_source=google&utm_campaign=1279_2024_all_seo_google_maps_local&utm_content=website&utm_term=3251",
      "poi_directions_map_url": "https://maps.google.com/?cid=18114910794360216742&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "qdoba-mexican-eats",
      "poi_latitude": "40.523147",
      "poi_longitude": "-74.45865239999999",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 58 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 732-463-1100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4d3c-7308-bd13-aeb63e21d0f8",
        "storage_key": "property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJH9MHqzbHw4kRpty6-2MXZfs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6180253e-932a-41a3-98f7-095f8a8bd46c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Panico's Restaurant & Bar",
      "poi_type": "Restaurants",
      "poi_address": "92 Church St, New Brunswick, NJ 08901, USA",
      "poi_short_description": "Italian restaurant & bar specializing in brick-oven pizza, plus pasta dinners, sandwiches & salads.",
      "poi_long_description": "Italian restaurant & bar specializing in brick-oven pizza, plus pasta dinners, sandwiches & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-129b-7629-ac1c-4a82c416066e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-129b-7629-ac1c-4a82c416066e",
        "storage_key": "property/6767906449166309/019fcdf3-129b-7629-ac1c-4a82c416066e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://panicosrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12596814075798572307&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "panicos-restaurant--bar",
      "poi_latitude": "40.4958252",
      "poi_longitude": "-74.4437018",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 732-545-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4d3c-7308-bd13-aeb63e21d0f8",
        "storage_key": "property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJuQ-VoFHGw4kRE02dQanf0K4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c9a2506b-e3ba-4d42-8d30-f657086ecfae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Casa Ragazzi",
      "poi_type": "Restaurants",
      "poi_address": "378 George St, New Brunswick, NJ 08901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-1252-777e-8d6d-fd398d94e772.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-1252-777e-8d6d-fd398d94e772",
        "storage_key": "property/6767906449166309/019fcdf3-1252-777e-8d6d-fd398d94e772.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.casaragazzinj.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18423387871874313324&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "casa-ragazzi",
      "poi_latitude": "40.4956944",
      "poi_longitude": "-74.4442737",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 732-317-1306",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4d3c-7308-bd13-aeb63e21d0f8",
        "storage_key": "property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJg-gMXMrHw4kRbOxOfqgFrf8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e55c83b3-752f-4336-914e-732887a16ce3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Friend's Cafe",
      "poi_type": "Restaurants",
      "poi_address": "52 Robinson St, New Brunswick, NJ 08901, USA",
      "poi_short_description": "Cozy cafe serving coffee, baked goods, and Persian dishes for breakfast and lunch.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-13a6-730d-985e-50a211ff89de.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-13a6-730d-985e-50a211ff89de",
        "storage_key": "property/6767906449166309/019fcdf3-13a6-730d-985e-50a211ff89de.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.friendscaferobinsonstreet.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=473464002963087829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "friends-cafe",
      "poi_latitude": "40.4983679",
      "poi_longitude": "-74.4564181",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 732-246-1241",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4dee-7465-b74f-36e3d3a25d75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4dee-7465-b74f-36e3d3a25d75",
        "storage_key": "property/6767906449166309/019d0266-4dee-7465-b74f-36e3d3a25d75.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJJYWoKIPHw4kR1aGMjgAVkgY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bbc6e9de-91dc-4473-8dfa-ce8c6157ac64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "25 Burgers",
      "poi_type": "Restaurants",
      "poi_address": "University Center at Easton Avenue, 4 Easton Ave, New Brunswick, NJ 08901, USA",
      "poi_short_description": "Familiar eatery serving gourmet burgers as well as fries and milkshakes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-1308-72ed-92a5-9742a67f428b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-1308-72ed-92a5-9742a67f428b",
        "storage_key": "property/6767906449166309/019fcdf3-1308-72ed-92a5-9742a67f428b.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "https://www.25burgers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6257604747838691870&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "25-burgers",
      "poi_latitude": "40.4966375",
      "poi_longitude": "-74.44704469999999",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 48 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 732-640-2600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4d3c-7308-bd13-aeb63e21d0f8",
        "storage_key": "property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJncoAylbGw4kRHhq5K11611Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1d8ce80b-de1c-4256-a518-e56e7d63b5c0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Stuff Yer Face",
      "poi_type": "Restaurants",
      "poi_address": "49 Easton Ave, New Brunswick, NJ 08901, USA",
      "poi_short_description": "Bi-level spot with stromboli sandwiches & loads of international beer, plus burgers, pizza & more.",
      "poi_long_description": "Bi-level spot with stromboli sandwiches & loads of international beer, plus burgers, pizza & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-1895-777a-a020-f8714a0d8a77.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-1895-777a-a020-f8714a0d8a77",
        "storage_key": "property/6767906449166309/019fcdf3-1895-777a-a020-f8714a0d8a77.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://stuffyerface.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=11389659131430089226&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stuff-yer-face",
      "poi_latitude": "40.498086",
      "poi_longitude": "-74.448959",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 732-247-1727",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4d3c-7308-bd13-aeb63e21d0f8",
        "storage_key": "property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJR9XhglbGw4kRCrKskaIyEJ4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_25fe9e13-ef5b-4ab0-80eb-6bfd3b57053f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Kimchihana Korean Japanese Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "6101 Hadley Rd, South Plainfield, NJ 07080, USA",
      "poi_short_description": "Korean-Japanese spot with table-grilled BBQ, many sides & sushi, in no-frills, strip-mall digs.",
      "poi_long_description": "Korean-Japanese spot with table-grilled BBQ, many sides & sushi, in no-frills, strip-mall digs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-1985-76be-93fe-b1f79ff6cf94.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-1985-76be-93fe-b1f79ff6cf94",
        "storage_key": "property/6767906449166309/019fcdf3-1985-76be-93fe-b1f79ff6cf94.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://kimchi-hana.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=10591120408070576082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kimchihana-korean-japanese-restaurant",
      "poi_latitude": "40.5539619",
      "poi_longitude": "-74.42772579999999",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "51 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 908-755-0777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4d3c-7308-bd13-aeb63e21d0f8",
        "storage_key": "property/6767906449166309/019d0266-4d3c-7308-bd13-aeb63e21d0f8.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzeLVu2y4w4kR0tdvoOU3-5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4198b3c8-c9c6-4ca4-922b-ef8a56cea01a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Cafe Nune",
      "poi_type": "Restaurants",
      "poi_address": "112 N Washington Ave, Dunellen, NJ 08812, USA",
      "poi_short_description": "Laid-back eatery specializing in bowls (açaí and sweet) as well as salads and juices (can be custom made).",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-194f-716f-8714-c36d3c1e38e4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-194f-716f-8714-c36d3c1e38e4",
        "storage_key": "property/6767906449166309/019fcdf3-194f-716f-8714-c36d3c1e38e4.webp",
        "width": 855,
        "height": 1280
      },
      "poi_business_url": "http://www.cafenune.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13713448057669440468&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cafe-nune",
      "poi_latitude": "40.5924687",
      "poi_longitude": "-74.4633391",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 732-629-7060",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4dee-7465-b74f-36e3d3a25d75.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4dee-7465-b74f-36e3d3a25d75",
        "storage_key": "property/6767906449166309/019d0266-4dee-7465-b74f-36e3d3a25d75.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJgw7B3wS5w4kR1FMo-1n0T74",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_53d83fa1-2c4b-4419-894b-8b64ac234f84",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "QuickChek",
      "poi_type": "Shopping & Retail",
      "poi_address": "191 Stelton Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "Convenience-store chain for snacks, coffee, breakfast & deli meals, along with gas-station service.",
      "poi_long_description": "Convenience-store chain for snacks, coffee, breakfast & deli meals, along with gas-station service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-1ad5-71a3-b15b-1b39c2d9ad58.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-1ad5-71a3-b15b-1b39c2d9ad58",
        "storage_key": "property/6767906449166309/019fcdf3-1ad5-71a3-b15b-1b39c2d9ad58.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://quickchek.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4594642711512149031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quickchek",
      "poi_latitude": "40.5689298",
      "poi_longitude": "-74.45641979999999",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 732-752-9718",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-841e-73d8-9b93-b04160283bb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fcdf3-841e-73d8-9b93-b04160283bb7",
        "storage_key": "property/6767906449166309/019fcdf3-841e-73d8-9b93-b04160283bb7.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJo3j6nva4w4kRJ-yE4TNzwz8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7748d7a2-6572-4a5a-9443-3135bc2b82c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Quick Stop Food Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "1665 Stelton Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-1f59-72ec-973a-63de94045b26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-1f59-72ec-973a-63de94045b26",
        "storage_key": "property/6767906449166309/019fcdf3-1f59-72ec-973a-63de94045b26.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=5802475821668573749&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quick-stop-food-store",
      "poi_latitude": "40.53409",
      "poi_longitude": "-74.419294",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 732-985-7318",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4df0-7404-91d2-f951722b050a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4df0-7404-91d2-f951722b050a",
        "storage_key": "property/6767906449166309/019d0266-4df0-7404-91d2-f951722b050a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJS6rhzvDHw4kRNSJZWASJhlA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f4317f62-91aa-4436-9201-35442740727d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Shopping & Retail",
      "poi_address": "1252 Stelton Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-2076-7002-901b-e5805b3b4336.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-2076-7002-901b-e5805b3b4336",
        "storage_key": "property/6767906449166309/019fcdf3-2076-7002-901b-e5805b3b4336.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/piscataway-nj-pharmacies/1252-stelton-rd-piscataway-nj-08854/storeid=759?WT.mc_id=LS_GOOGLE_RX_759",
      "poi_directions_map_url": "https://maps.google.com/?cid=15573971668751014230&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.5414155",
      "poi_longitude": "-74.42444449999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 732-339-0672",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-519b-76ad-9c61-ca5bfedbe7b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-519b-76ad-9c61-ca5bfedbe7b2",
        "storage_key": "property/6767906449166309/019d0266-519b-76ad-9c61-ca5bfedbe7b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVDfOQq4w4kRVtnm4bfcIdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_dda1215a-4d65-46fb-a734-cb5235373c58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Shopping & Retail",
      "poi_address": "440 S Washington Ave #456, Piscataway, NJ 08854, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-1fb5-700a-a5ef-bf506134a87f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-1fb5-700a-a5ef-bf506134a87f",
        "storage_key": "property/6767906449166309/019fcdf3-1fb5-700a-a5ef-bf506134a87f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-440+s+washington+ave-piscataway-nj-08854/id=7124",
      "poi_directions_map_url": "https://maps.google.com/?cid=18407955966771884963&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "40.5812827",
      "poi_longitude": "-74.455444",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "41 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 732-424-3666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-522b-70ec-b794-39082eb7e549",
        "storage_key": "property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJxT8Osv-4w4kRo3N4GGwydv8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5be2f8f8-8070-476a-adf1-00394b1507f3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "ALDI",
      "poi_type": "Shopping & Retail",
      "poi_address": "1321 Centennial Ave, Piscataway, NJ 08854, USA",
      "poi_short_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_long_description": "Retail chain selling a range of grocery items, meat & dairy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-21cb-749a-8783-b7b5eb864377.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-21cb-749a-8783-b7b5eb864377",
        "storage_key": "property/6767906449166309/019fcdf3-21cb-749a-8783-b7b5eb864377.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://stores.aldi.us/nj/piscataway/1321-centennial-avenue?utm_source=google&utm_medium=local&utm_campaign=brand&utm_content=storepage_webclick",
      "poi_directions_map_url": "https://maps.google.com/?cid=17264082155541933408&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "aldi",
      "poi_latitude": "40.5522099",
      "poi_longitude": "-74.4388249",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 855-955-2534",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4df0-7404-91d2-f951722b050a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4df0-7404-91d2-f951722b050a",
        "storage_key": "property/6767906449166309/019d0266-4df0-7404-91d2-f951722b050a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP_hitny4w4kRYK08XkBXlu8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_459b9ae8-e4fe-4106-99ec-8e5845c38725",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Walmart",
      "poi_type": "Shopping & Retail",
      "poi_address": "1303 Centennial Ave, Piscataway, NJ 08854, USA",
      "poi_short_description": "Big, well-stocked chain store offering groceries, home furniture, appliances, toys, apparel, electronics and more.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-2600-754b-9a57-28488b592477.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-2600-754b-9a57-28488b592477",
        "storage_key": "property/6767906449166309/019fcdf3-2600-754b-9a57-28488b592477.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/2633-piscataway-nj?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=8436803065203083485&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart",
      "poi_latitude": "40.5546875",
      "poi_longitude": "-74.4413881",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 732-562-1771",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4d3e-75db-9f2a-1826ecb64a4d.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4d3e-75db-9f2a-1826ecb64a4d",
        "storage_key": "property/6767906449166309/019d0266-4d3e-75db-9f2a-1826ecb64a4d.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ6ZdygG-4w4kR3UhbDbCLFXU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_df392036-3c91-4de1-90c7-74d807dfd23e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Asian Food Market of Piscataway",
      "poi_type": "Shopping & Retail",
      "poi_address": "1339 Centennial Ave, Piscataway, NJ 08854, USA",
      "poi_short_description": "Clean Asian supermarket featuring fresh produce, seafood and baked goods.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-254a-70da-b047-b98c586c3fe7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-254a-70da-b047-b98c586c3fe7",
        "storage_key": "property/6767906449166309/019fcdf3-254a-70da-b047-b98c586c3fe7.webp",
        "width": 1280,
        "height": 719
      },
      "poi_business_url": "http://www.asianfoodmarkets.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12562657848241476626&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "asian-food-market-of-piscataway",
      "poi_latitude": "40.553704",
      "poi_longitude": "-74.4379175",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "46 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 732-645-3018",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4df0-7404-91d2-f951722b050a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4df0-7404-91d2-f951722b050a",
        "storage_key": "property/6767906449166309/019d0266-4df0-7404-91d2-f951722b050a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV4-wE264w4kREtQ0z8CGV64",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e3ed8518-8417-4760-9632-3082c8961dab",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Food Bazaar Piscataway",
      "poi_type": "Shopping & Retail",
      "poi_address": "581 Stelton Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "Supermarket chain offering traditional groceries & produce, along with international items.",
      "poi_long_description": "Supermarket chain offering traditional groceries & produce, along with international items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-278f-7409-b823-3f3436080db6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-278f-7409-b823-3f3436080db6",
        "storage_key": "property/6767906449166309/019fcdf3-278f-7409-b823-3f3436080db6.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "https://foodbazaar.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8086485557595750380&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-bazaar-piscataway",
      "poi_latitude": "40.5609505",
      "poi_longitude": "-74.43955609999999",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 732-968-5100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4df0-7404-91d2-f951722b050a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4df0-7404-91d2-f951722b050a",
        "storage_key": "property/6767906449166309/019d0266-4df0-7404-91d2-f951722b050a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQwLNLWW5w4kR7D_SRcX3OHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b54bc51a-3217-4a04-a8be-8f6247bd734a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Subhlaxmi Cash & Carry",
      "poi_type": "Shopping & Retail",
      "poi_address": "550 Stelton Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "Grocery store carrying Indian products including pooja items and spices, plus cookware.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-285e-739b-8036-04b4d4585c03.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-285e-739b-8036-04b4d4585c03",
        "storage_key": "property/6767906449166309/019fcdf3-285e-739b-8036-04b4d4585c03.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://subhlaxmigrocers.com/contact-us/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2757723765117300041&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "subhlaxmi-cash--carry",
      "poi_latitude": "40.5595602",
      "poi_longitude": "-74.4435161",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 732-529-5871",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-4df0-7404-91d2-f951722b050a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-4df0-7404-91d2-f951722b050a",
        "storage_key": "property/6767906449166309/019d0266-4df0-7404-91d2-f951722b050a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjUQMq2e4w4kRSS14QCdnRSY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8dbad123-bbaa-4374-91f2-988ad81495cb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Krauszer's Food Store",
      "poi_type": "Shopping & Retail",
      "poi_address": "424 S Washington Ave, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-2bf7-7713-be3c-7bb13dfc695f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-2bf7-7713-be3c-7bb13dfc695f",
        "storage_key": "property/6767906449166309/019fcdf3-2bf7-7713-be3c-7bb13dfc695f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=16426631548580742722&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "krauszers-food-store",
      "poi_latitude": "40.58202800000001",
      "poi_longitude": "-74.4556837",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 732-752-7424",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-841e-73d8-9b93-b04160283bb7.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fcdf3-841e-73d8-9b93-b04160283bb7",
        "storage_key": "property/6767906449166309/019fcdf3-841e-73d8-9b93-b04160283bb7.webp",
        "width": 192,
        "height": 161
      },
      "poi_google_place_id": "ChIJUSLltP-4w4kRQkZhhVwe9-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0211ff5a-901b-42e4-af4a-b75426e450d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Piscataway High School",
      "poi_type": "Education",
      "poi_address": "100 Behmer Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-2c0b-757e-892b-6e1b475a20f1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-2c0b-757e-892b-6e1b475a20f1",
        "storage_key": "property/6767906449166309/019fcdf3-2c0b-757e-892b-6e1b475a20f1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://piscatawayschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11647685529612346389&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "piscataway-high-school",
      "poi_latitude": "40.5469455",
      "poi_longitude": "-74.4719624",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 732-981-0700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5206-73f5-8bf5-59d787c50a38",
        "storage_key": "property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJnXqhjJ-4w4kRFWQA8EbkpKE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5713011b-beb7-4cf7-8100-059ffcc9a69f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Quibbletown Middle School",
      "poi_type": "Education",
      "poi_address": "99 Academy St, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://quibbletown.piscatawayschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9341093731211634536&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quibbletown-middle-school",
      "poi_latitude": "40.5737909",
      "poi_longitude": "-74.4516288",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 732-752-0444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5206-73f5-8bf5-59d787c50a38",
        "storage_key": "property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJGRG74Fe4w4kRaGd_3kE7ooE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_53cc3f0f-dfb5-4318-b296-839e394e8d64",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Conackamack Middle School",
      "poi_type": "Education",
      "poi_address": "5205 Witherspoon St, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-2e6c-7082-a99d-80249b4f8736.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-2e6c-7082-a99d-80249b4f8736",
        "storage_key": "property/6767906449166309/019fcdf3-2e6c-7082-a99d-80249b4f8736.webp",
        "width": 1280,
        "height": 659
      },
      "poi_business_url": "http://conackamack.piscatawayschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15826340744072388984&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "conackamack-middle-school",
      "poi_latitude": "40.5348007",
      "poi_longitude": "-74.47729559999999",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 732-699-1577",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5206-73f5-8bf5-59d787c50a38",
        "storage_key": "property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-6aV-ELHw4kReOG5IA51ots",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_288b355c-73cd-4356-984f-97e0cd04ef17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Theodore Schor Middle School",
      "poi_type": "Education",
      "poi_address": "243 N Randolphville Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://schor.piscatawayschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7603924389732607008&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "theodore-schor-middle-school",
      "poi_latitude": "40.5642083",
      "poi_longitude": "-74.46679999999999",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 732-752-4457",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5206-73f5-8bf5-59d787c50a38",
        "storage_key": "property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ--cZ-pK4w4kRIOTw9PGQhmk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ffb7a720-6a54-4030-b02b-5e4496774a7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Martin Luther King Intermediate School",
      "poi_type": "Education",
      "poi_address": "5205 Ludlow St, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-2e9a-720a-9724-3ad93043dcde.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-2e9a-720a-9724-3ad93043dcde",
        "storage_key": "property/6767906449166309/019fcdf3-2e9a-720a-9724-3ad93043dcde.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://king.piscatawayschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12054896976619386031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "martin-luther-king-intermediate-school",
      "poi_latitude": "40.5339134",
      "poi_longitude": "-74.47994489999999",
      "poi_miles_from_property": "5",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 732-699-1563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5206-73f5-8bf5-59d787c50a38",
        "storage_key": "property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJbcGF5UPHw4kRrzRUP-6YS6c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c4364b63-2225-469e-afc0-d5c77ebbfe12",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Arbor Intermediate School",
      "poi_type": "Education",
      "poi_address": "1717 Lester Pl, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-325d-778f-83ee-9f5a8b255ed1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-325d-778f-83ee-9f5a8b255ed1",
        "storage_key": "property/6767906449166309/019fcdf3-325d-778f-83ee-9f5a8b255ed1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://arbor.piscatawayschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=540057468683721834&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arbor-intermediate-school",
      "poi_latitude": "40.59063769999999",
      "poi_longitude": "-74.44738869999999",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 732-752-8652",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5206-73f5-8bf5-59d787c50a38",
        "storage_key": "property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJYyd1vqi5w4kRapwwC2irfgc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_80818cc6-a08f-4047-90f2-727ea187e486",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Knollwood Elementary School",
      "poi_type": "Education",
      "poi_address": "333 Willow Ave, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://knollwood.piscatawayschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17736966493950461290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "knollwood-elementary-school",
      "poi_latitude": "40.5383763",
      "poi_longitude": "-74.4873951",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 732-885-1528",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5206-73f5-8bf5-59d787c50a38",
        "storage_key": "property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ65sVD1DHw4kRakXsQA1dJvY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_94db1418-266a-40b7-986e-b873a35b349d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Randolphville Elementary School",
      "poi_type": "Education",
      "poi_address": "1 Suttie Ave, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://piscatawayschools.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3114054279509204245&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "randolphville-elementary-school",
      "poi_latitude": "40.5466998",
      "poi_longitude": "-74.4499709",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 732-699-1573",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5206-73f5-8bf5-59d787c50a38",
        "storage_key": "property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJd4LpV364w4kRFV1uRd5XNys",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_55a39a42-b2c6-45a0-b6e6-88e94f2da98d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Children’s Corner Preschool",
      "poi_type": "Education",
      "poi_address": "275 Old New Brunswick Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-3226-729a-bbcc-2fc54b875b53.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-3226-729a-bbcc-2fc54b875b53",
        "storage_key": "property/6767906449166309/019fcdf3-3226-729a-bbcc-2fc54b875b53.webp",
        "width": 1280,
        "height": 561
      },
      "poi_business_url": "http://ccprek.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4379961999723653320&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "childrens-corner-preschool",
      "poi_latitude": "40.5508416",
      "poi_longitude": "-74.4748134",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 732-981-4430",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5206-73f5-8bf5-59d787c50a38",
        "storage_key": "property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJlX7f3Pu4w4kRyOg8kzvAyDw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0367ecdb-dff7-447a-8ad5-8f919583e537",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Visitor Center",
      "poi_type": "Education",
      "poi_address": "100 Sutphen Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "Visitor center on a campus with parking, a garden, and a bus service.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-357b-778a-805c-39f365f0afe3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-357b-778a-805c-39f365f0afe3",
        "storage_key": "property/6767906449166309/019fcdf3-357b-778a-805c-39f365f0afe3.webp",
        "width": 1280,
        "height": 964
      },
      "poi_business_url": "http://newbrunswick.rutgers.edu/visit/visitor-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=16075606892302386080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "visitor-center",
      "poi_latitude": "40.5161171",
      "poi_longitude": "-74.46036169999999",
      "poi_miles_from_property": "5.9",
      "poi_walking_minutes": "2 hours 11 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 848-445-1000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-522b-70ec-b794-39082eb7e549",
        "storage_key": "property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJX4xbEg_Hw4kRoEOB3EsHGN8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b88e5bd9-4c56-49d2-b264-fd14fb299e98",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Rutgers Cinema",
      "poi_type": "Entertainment",
      "poi_address": "105 Joyce Kilmer Ave, Piscataway, NJ 08854, USA",
      "poi_short_description": "Independent movie theater on campus, featuring blockbuster films & weekly concession specials.",
      "poi_long_description": "Independent movie theater on campus, featuring blockbuster films & weekly concession specials.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-3521-74cb-a12f-2d59af6852e0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-3521-74cb-a12f-2d59af6852e0",
        "storage_key": "property/6767906449166309/019fcdf3-3521-74cb-a12f-2d59af6852e0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.rutgerscinema.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6606463366204339242&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rutgers-cinema",
      "poi_latitude": "40.5253879",
      "poi_longitude": "-74.4374739",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 848-445-1124",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-522d-706e-92e9-c4972f2f2d42.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-522d-706e-92e9-c4972f2f2d42",
        "storage_key": "property/6767906449166309/019d0266-522d-706e-92e9-c4972f2f2d42.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJg62b3pbHw4kRKrQ91G3frls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9c7d3b0b-4087-4092-b1b2-df56639463e5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Rutgers Gardens",
      "poi_type": "Entertainment",
      "poi_address": "130 Log Cabin Rd, New Brunswick, NJ 08901, USA",
      "poi_short_description": "Serene, year-round destination featuring botanical gardens & a bamboo forest, plus areas for events.",
      "poi_long_description": "Serene, year-round destination featuring botanical gardens & a bamboo forest, plus areas for events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-39fe-7691-9fe0-42d7fdd70d23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-39fe-7691-9fe0-42d7fdd70d23",
        "storage_key": "property/6767906449166309/019fcdf3-39fe-7691-9fe0-42d7fdd70d23.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rutgersgardens.rutgers.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12382073806360168095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rutgers-gardens",
      "poi_latitude": "40.473396",
      "poi_longitude": "-74.4226937",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 848-932-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5850-76de-a0a2-e6e9553ee8f6",
        "storage_key": "property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKw0kXxHGw4kRn0bEGob21as",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b1887e79-cdcb-4bae-8bd5-7f77af396cb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Zimmerli Art Museum, Rutgers University",
      "poi_type": "Entertainment",
      "poi_address": "71 Hamilton St, New Brunswick, NJ 08901, USA",
      "poi_short_description": "Museum at Rutgers University with 60,000 objects of ancient & modern art from around the world.",
      "poi_long_description": "Museum at Rutgers University with 60,000 objects of ancient & modern art from around the world.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-3929-7738-8878-6442d32199b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-3929-7738-8878-6442d32199b8",
        "storage_key": "property/6767906449166309/019fcdf3-3929-7738-8878-6442d32199b8.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://zimmerli.rutgers.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6382647714279668848&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "zimmerli-art-museum-rutgers-university",
      "poi_latitude": "40.4997749",
      "poi_longitude": "-74.44582799999999",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 848-932-7237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-56f5-725a-a827-9d91358ea85e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-56f5-725a-a827-9d91358ea85e",
        "storage_key": "property/6767906449166309/019d0266-56f5-725a-a827-9d91358ea85e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJ2bZcmlPGw4kRcDwZiEe4k1g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1509b3bd-22ad-4a04-9643-147a20ea7d2a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "State Theatre New Jersey",
      "poi_type": "Entertainment",
      "poi_address": "15 Livingston Ave, New Brunswick, NJ 08901, USA",
      "poi_short_description": "Nonprofit performance venue showcasing a range of entertainment including music, comedy & plays.",
      "poi_long_description": "Nonprofit performance venue showcasing a range of entertainment including music, comedy & plays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-3c16-73da-a720-0f58d8a4a04c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-3c16-73da-a720-0f58d8a4a04c",
        "storage_key": "property/6767906449166309/019fcdf3-3c16-73da-a720-0f58d8a4a04c.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.stnj.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12801531443670275292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "state-theatre-new-jersey",
      "poi_latitude": "40.4932726",
      "poi_longitude": "-74.44464769999999",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 732-246-7469",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-522b-70ec-b794-39082eb7e549",
        "storage_key": "property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJIf1qhVDGw4kR3NT1yAUtqLE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ebe23781-543d-4904-bb55-327b45d35a0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "George Street Playhouse",
      "poi_type": "Entertainment",
      "poi_address": "9 Livingston Avenue at the, Performing Arts Center, New Brunswick, NJ 08901, USA",
      "poi_short_description": "Showcase for new & established plays, presenting both on & Off-Broadway theater productions.",
      "poi_long_description": "Showcase for new & established plays, presenting both on & Off-Broadway theater productions.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-3cb8-7681-9588-144f654408f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-3cb8-7681-9588-144f654408f0",
        "storage_key": "property/6767906449166309/019fcdf3-3cb8-7681-9588-144f654408f0.webp",
        "width": 1280,
        "height": 985
      },
      "poi_business_url": "http://www.georgestreetplayhouse.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6743042466688212639&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-street-playhouse",
      "poi_latitude": "40.4936074",
      "poi_longitude": "-74.4443807",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 732-246-7717",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-522b-70ec-b794-39082eb7e549",
        "storage_key": "property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJQWkkjFDGw4kRnx5TtGUZlF0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_00cd0fbc-7da8-445b-84f7-29bd2ee2172f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Crossroads Theatre Company",
      "poi_type": "Entertainment",
      "poi_address": "9 Livingston Ave #412, New Brunswick, NJ 08901, USA",
      "poi_short_description": "Distinguished theater showcases works that examine the African-American experience.",
      "poi_long_description": "Distinguished theater showcases works that examine the African-American experience.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-3fc8-7794-938a-c16eecb77488.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-3fc8-7794-938a-c16eecb77488",
        "storage_key": "property/6767906449166309/019fcdf3-3fc8-7794-938a-c16eecb77488.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.crossroadstheatrecompany.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6572024099255028013&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "crossroads-theatre-company",
      "poi_latitude": "40.4934974",
      "poi_longitude": "-74.4442274",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 732-258-7530",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-522b-70ec-b794-39082eb7e549",
        "storage_key": "property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJC8tdilDGw4kRLQlnIxmFNFs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_23e942c4-f82a-4115-8e2e-186378cf840d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Rutgers Geology Museum",
      "poi_type": "Entertainment",
      "poi_address": "85 Somerset St, New Brunswick, NJ 08901, USA",
      "poi_short_description": "Minerals, fossil collections, geologic specimens & a mummy in a historic museum built in 1872.",
      "poi_long_description": "Minerals, fossil collections, geologic specimens & a mummy in a historic museum built in 1872.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-41cb-76fc-9166-7886d3ba1dfb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-41cb-76fc-9166-7886d3ba1dfb",
        "storage_key": "property/6767906449166309/019fcdf3-41cb-76fc-9166-7886d3ba1dfb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://geologymuseum.rutgers.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17477330291817732275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rutgers-geology-museum",
      "poi_latitude": "40.498649",
      "poi_longitude": "-74.4466806",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 848-932-7243",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-56f5-725a-a827-9d91358ea85e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-56f5-725a-a827-9d91358ea85e",
        "storage_key": "property/6767906449166309/019d0266-56f5-725a-a827-9d91358ea85e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJJWqBdwjHw4kRs1j4MU3zi_I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6d228fc8-c27a-4c81-9121-a5b86273c245",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Metlar-Bodine House Museum",
      "poi_type": "Entertainment",
      "poi_address": "1281 River Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "Preserved private residence displaying more than 1,000 artifacts of regional historical interest.",
      "poi_long_description": "Preserved private residence displaying more than 1,000 artifacts of regional historical interest.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-4326-70dc-9aa4-9a83a4846a20.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-4326-70dc-9aa4-9a83a4846a20",
        "storage_key": "property/6767906449166309/019fcdf3-4326-70dc-9aa4-9a83a4846a20.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.metlarbodinehousemuseum.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3883808028451527275&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metlar-bodine-house-museum",
      "poi_latitude": "40.5129379",
      "poi_longitude": "-74.4569042",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 26 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 732-463-8363",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-56f5-725a-a827-9d91358ea85e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-56f5-725a-a827-9d91358ea85e",
        "storage_key": "property/6767906449166309/019d0266-56f5-725a-a827-9d91358ea85e.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJg1Y2ywXHw4kRa9qpF9MO5jU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_309dca50-eaf5-4912-9951-037e68bec71a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Department of Physics & Astronomy",
      "poi_type": "Entertainment",
      "poi_address": "136 Frelinghuysen Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-43e5-729b-95da-e3f460842334.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-43e5-729b-95da-e3f460842334",
        "storage_key": "property/6767906449166309/019fcdf3-43e5-729b-95da-e3f460842334.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.physics.rutgers.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4266618090775459494&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "department-of-physics--astronomy",
      "poi_latitude": "40.5229985",
      "poi_longitude": "-74.4647229",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 848-445-8781",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5206-73f5-8bf5-59d787c50a38",
        "storage_key": "property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJezwbhBLHw4kRpjbtTIwSNjs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_aeeb6da9-ebb7-47f5-ba45-9610e484d196",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "New Brunswick Performing Arts Center (NBPAC)",
      "poi_type": "Entertainment",
      "poi_address": "11 Livingston Ave, New Brunswick, NJ 08901, USA",
      "poi_short_description": "Modern space for musical performances, ballet and plays, as well as two smaller theaters.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-4689-746e-a3e5-84fea24b29e7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-4689-746e-a3e5-84fea24b29e7",
        "storage_key": "property/6767906449166309/019fcdf3-4689-746e-a3e5-84fea24b29e7.webp",
        "width": 1280,
        "height": 1260
      },
      "poi_business_url": "http://nbpac.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12962552693172407693&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-brunswick-performing-arts-center-nbpac",
      "poi_latitude": "40.4933955",
      "poi_longitude": "-74.4442165",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 732-745-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-522b-70ec-b794-39082eb7e549",
        "storage_key": "property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrcz80iLHw4kRjQ3T8v485LM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4510270e-e1c5-456a-a555-5720cdf77ec7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Robert Wood Johnson University Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "1 Robert Wood Johnson Pl, New Brunswick, NJ 08901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-4892-723e-9ae7-22d3d3f208a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-4892-723e-9ae7-22d3d3f208a8",
        "storage_key": "property/6767906449166309/019fcdf3-4892-723e-9ae7-22d3d3f208a8.webp",
        "width": 959,
        "height": 723
      },
      "poi_business_url": "https://www.rwjbh.org/rwj-university-hospital-new-brunswick/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5260900183843214550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robert-wood-johnson-university-hospital",
      "poi_latitude": "40.4951556",
      "poi_longitude": "-74.4500083",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 732-828-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5859-77bb-82b5-7e02e9aef182.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5859-77bb-82b5-7e02e9aef182",
        "storage_key": "property/6767906449166309/019d0266-5859-77bb-82b5-7e02e9aef182.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLXT741bGw4kR1hTDANh4Akk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_cbcc4a38-1267-43f4-8419-ec901a0ffeaf",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Hackensack Meridian Urgent Care - Piscataway",
      "poi_type": "Health and Wellness",
      "poi_address": "1080 Stelton Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-4a36-765d-891a-bebb64d3f1cd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-4a36-765d-891a-bebb64d3f1cd",
        "storage_key": "property/6767906449166309/019fcdf3-4a36-765d-891a-bebb64d3f1cd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.hackensackmeridianhealth.org/en/Locations/Hackensack-Meridian-Urgent-Care---Piscataway",
      "poi_directions_map_url": "https://maps.google.com/?cid=10459400890714566826&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hackensack-meridian-urgent-care---piscataway",
      "poi_latitude": "40.54793919999999",
      "poi_longitude": "-74.429481",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 848-230-6800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-522b-70ec-b794-39082eb7e549",
        "storage_key": "property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUi9KKC5w4kRqjBynrFBJ5E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8b6d7939-40b2-46b5-8d89-1588c09ab105",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "AFC Urgent Care Piscataway",
      "poi_type": "Health and Wellness",
      "poi_address": "1315 Stelton Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-4aaa-7461-8cd9-6310639ed350.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-4aaa-7461-8cd9-6310639ed350",
        "storage_key": "property/6767906449166309/019fcdf3-4aaa-7461-8cd9-6310639ed350.webp",
        "width": 1280,
        "height": 832
      },
      "poi_business_url": "https://www.afcurgentcare.com/piscataway/?utm_source=gmb&utm_medium=organic&utm_campaign=afc-piscataway",
      "poi_directions_map_url": "https://maps.google.com/?cid=5714510863156402778&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "afc-urgent-care-piscataway",
      "poi_latitude": "40.5411837",
      "poi_longitude": "-74.42302169999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 732-339-3690",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-522b-70ec-b794-39082eb7e549",
        "storage_key": "property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJn-Hguua5w4kRWlqMb1oFTk8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f6d9e8ea-e6c0-463f-b385-f854931745b2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1252 Stelton Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-2076-7002-901b-e5805b3b4336.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-2076-7002-901b-e5805b3b4336",
        "storage_key": "property/6767906449166309/019fcdf3-2076-7002-901b-e5805b3b4336.webp",
        "width": 1100,
        "height": 743
      },
      "poi_business_url": "https://www.cvs.com/store-locator/piscataway-nj-pharmacies/1252-stelton-rd-piscataway-nj-08854/storeid=759?WT.mc_id=LS_GOOGLE_RX_759",
      "poi_directions_map_url": "https://maps.google.com/?cid=15573971668751014230&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "40.5414155",
      "poi_longitude": "-74.42444449999999",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 732-339-0672",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-519b-76ad-9c61-ca5bfedbe7b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-519b-76ad-9c61-ca5bfedbe7b2",
        "storage_key": "property/6767906449166309/019d0266-519b-76ad-9c61-ca5bfedbe7b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgVDfOQq4w4kRVtnm4bfcIdg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1900bea9-537c-4913-bbd1-be04430e03ce",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Stelton Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "179 Stelton Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-4d17-74fd-8c1f-6b1f7586ada9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-4d17-74fd-8c1f-6b1f7586ada9",
        "storage_key": "property/6767906449166309/019fcdf3-4d17-74fd-8c1f-6b1f7586ada9.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://stores.healthmart.com/steltonpharmacy",
      "poi_directions_map_url": "https://maps.google.com/?cid=17699252666228403560&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "stelton-pharmacy",
      "poi_latitude": "40.5694464",
      "poi_longitude": "-74.4564563",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 732-424-8080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-519b-76ad-9c61-ca5bfedbe7b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-519b-76ad-9c61-ca5bfedbe7b2",
        "storage_key": "property/6767906449166309/019d0266-519b-76ad-9c61-ca5bfedbe7b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-16Dl_a4w4kRaO1teIZgoPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b18e721e-8911-4804-96f6-2b60eb44d6c9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "440 S Washington Ave #456, Piscataway, NJ 08854, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-4f68-71eb-a47d-1553ffd04e79.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-4f68-71eb-a47d-1553ffd04e79",
        "storage_key": "property/6767906449166309/019fcdf3-4f68-71eb-a47d-1553ffd04e79.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-440+s+washington+ave-piscataway-nj-08854/id=7124",
      "poi_directions_map_url": "https://maps.google.com/?cid=11487659646395912621&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "40.581327",
      "poi_longitude": "-74.45543599999999",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 732-424-3666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-519b-76ad-9c61-ca5bfedbe7b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-519b-76ad-9c61-ca5bfedbe7b2",
        "storage_key": "property/6767906449166309/019d0266-519b-76ad-9c61-ca5bfedbe7b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJV8TxVP64w4kRrZEEjJVdbJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_05a39f82-333a-4c79-ac64-894e2f814e4e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Walmart Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "1303 Centennial Ave, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-505c-7154-82f4-0a818760f1d9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-505c-7154-82f4-0a818760f1d9",
        "storage_key": "property/6767906449166309/019fcdf3-505c-7154-82f4-0a818760f1d9.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.walmart.com/store/2633-piscataway-nj/pharmacy/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=14476693383573977000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-pharmacy",
      "poi_latitude": "40.5546875",
      "poi_longitude": "-74.4413881",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 732-562-1777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-519b-76ad-9c61-ca5bfedbe7b2.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-519b-76ad-9c61-ca5bfedbe7b2",
        "storage_key": "property/6767906449166309/019d0266-519b-76ad-9c61-ca5bfedbe7b2.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6ZdygG-4w4kRqLcseu6L58g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_6e436e1d-5454-40b4-9cc4-6e721bd5f05b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "The YMCA at the Piscataway Community Center",
      "poi_type": "Health and Wellness",
      "poi_address": "520 Hoes Ln, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-5097-76db-9f9a-b7d5b470b032.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-5097-76db-9f9a-b7d5b470b032",
        "storage_key": "property/6767906449166309/019fcdf3-5097-76db-9f9a-b7d5b470b032.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.ymcaofmewsa.org/locations/the-ymca-at-the-piscataway-community-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=15479045504125688133&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-ymca-at-the-piscataway-community-center",
      "poi_latitude": "40.5351341",
      "poi_longitude": "-74.4706442",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 732-562-2302",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-522b-70ec-b794-39082eb7e549",
        "storage_key": "property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJkyCCHarHw4kRRdmE39-d0NY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_869fc2a1-fc82-453b-a7f3-f2b65cb1e439",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "HOTWORX - Piscataway, NJ",
      "poi_type": "Health and Wellness",
      "poi_address": "1642 Stelton Rd SUITE 401, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-5441-70fb-ae56-1b2f6dc0ad6e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-5441-70fb-ae56-1b2f6dc0ad6e",
        "storage_key": "property/6767906449166309/019fcdf3-5441-70fb-ae56-1b2f6dc0ad6e.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.hotworx.net/studio/piscataway",
      "poi_directions_map_url": "https://maps.google.com/?cid=13680066541970430824&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hotworx---piscataway-nj",
      "poi_latitude": "40.5333877",
      "poi_longitude": "-74.4201782",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 20 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 908-379-9679",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5206-73f5-8bf5-59d787c50a38",
        "storage_key": "property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzZ9QMwHHw4kRaJvaMQpc2b0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_ac5cdbf2-b6c6-40b3-a070-8ba21f37b714",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Sonny Werblin Recreation Center",
      "poi_type": "Health and Wellness",
      "poi_address": "656 Bartholomew Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "Complex featuring a large pool as well as basketball and volleyball courts and a gym.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-5624-7626-ad52-5449094c2070.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-5624-7626-ad52-5449094c2070",
        "storage_key": "property/6767906449166309/019fcdf3-5624-7626-ad52-5449094c2070.webp",
        "width": 1280,
        "height": 427
      },
      "poi_business_url": "http://recreation.rutgers.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5364892656857957991&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sonny-werblin-recreation-center",
      "poi_latitude": "40.5195286",
      "poi_longitude": "-74.4608847",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 848-445-0460",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-522b-70ec-b794-39082eb7e549",
        "storage_key": "property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjb5XVwvHw4kRZ8YebnLtc0o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5081a2c7-5724-404d-995b-6068e2d7da8b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Johnson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "River Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "Historic village, picnic grounds & sport courts on 473 acres with paths & 2 ponds.",
      "poi_long_description": "Historic village, picnic grounds & sport courts on 473 acres with paths & 2 ponds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-5729-755f-9f4b-e4972c6ea24c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-5729-755f-9f4b-e4972c6ea24c",
        "storage_key": "property/6767906449166309/019fcdf3-5729-755f-9f4b-e4972c6ea24c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.middlesexcountynj.gov/About/ParksRecreation/Pages/PR/Johnson-Park.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=10169715988617987171&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson-park",
      "poi_latitude": "40.5094399",
      "poi_longitude": "-74.4592469",
      "poi_miles_from_property": "6.3",
      "poi_walking_minutes": "2 hours 20 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 732-745-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5850-76de-a0a2-e6e9553ee8f6",
        "storage_key": "property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJB9goWADHw4kRY4QvaM8WIo0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8e6f1a4c-915b-4230-8a83-3ce8ea6d4bbb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Donaldson Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "526 S 2nd Ave, Highland Park, NJ 08904, USA",
      "poi_short_description": "90-acre riverfront park provides sports fields & courts, picnic groves, a dog park & 2 playgrounds.",
      "poi_long_description": "90-acre riverfront park provides sports fields & courts, picnic groves, a dog park & 2 playgrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-5781-72a8-98a0-e09e691b2958.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-5781-72a8-98a0-e09e691b2958",
        "storage_key": "property/6767906449166309/019fcdf3-5781-72a8-98a0-e09e691b2958.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.middlesexcountynj.gov/Home/Components/FacilityDirectory/FacilityDirectory/55/36",
      "poi_directions_map_url": "https://maps.google.com/?cid=17324276450345617150&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "donaldson-park",
      "poi_latitude": "40.4902679",
      "poi_longitude": "-74.42437160000001",
      "poi_miles_from_property": "7.3",
      "poi_walking_minutes": "2 hours 43 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 732-745-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5850-76de-a0a2-e6e9553ee8f6",
        "storage_key": "property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJe0JPXDfGw4kR_gaExaQxbPA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b370d1b2-56f8-40a4-8614-a6042367cacc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Quibbletown Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Fairview Ave, Piscataway, NJ 08854, USA",
      "poi_short_description": "Spacious park, featuring playgrounds, tennis courts, basketball courts and soccer fields.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-5c30-723a-9065-e33e0e3ff110.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-5c30-723a-9065-e33e0e3ff110",
        "storage_key": "property/6767906449166309/019fcdf3-5c30-723a-9065-e33e0e3ff110.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.piscatawaynj.org/departments/recreation/township_parks_and_playgrounds.php",
      "poi_directions_map_url": "https://maps.google.com/?cid=8840990792259140476&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quibbletown-park",
      "poi_latitude": "40.5734475",
      "poi_longitude": "-74.448594",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 732-562-2382",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5850-76de-a0a2-e6e9553ee8f6",
        "storage_key": "property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAeK4ble4w4kRfPsas0iCsXo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_c039c141-6ead-4d20-b8c2-a753d82b8cc8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Spring Lake Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2505 Plainfield Ave, South Plainfield, NJ 07080, USA",
      "poi_short_description": "Public park offering tennis and basketball courts, a playground, and walking paths.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-5d25-7562-a2c2-8cd00981eb6d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-5d25-7562-a2c2-8cd00981eb6d",
        "storage_key": "property/6767906449166309/019fcdf3-5d25-7562-a2c2-8cd00981eb6d.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.middlesexcountynj.gov/Home/Components/FacilityDirectory/FacilityDirectory/69/36?npage=2",
      "poi_directions_map_url": "https://maps.google.com/?cid=3612896178418121630&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "spring-lake-park",
      "poi_latitude": "40.5851196",
      "poi_longitude": "-74.4112245",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5850-76de-a0a2-e6e9553ee8f6",
        "storage_key": "property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJv6-mdNG5w4kRnnv6rO6VIzI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bfb0ffe9-70e9-450d-bbf9-7cf617970cfe",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Rutgers Gardens",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "130 Log Cabin Rd, New Brunswick, NJ 08901, USA",
      "poi_short_description": "Serene, year-round destination featuring botanical gardens & a bamboo forest, plus areas for events.",
      "poi_long_description": "Serene, year-round destination featuring botanical gardens & a bamboo forest, plus areas for events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-39fe-7691-9fe0-42d7fdd70d23.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-39fe-7691-9fe0-42d7fdd70d23",
        "storage_key": "property/6767906449166309/019fcdf3-39fe-7691-9fe0-42d7fdd70d23.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rutgersgardens.rutgers.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12382073806360168095&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rutgers-gardens",
      "poi_latitude": "40.473396",
      "poi_longitude": "-74.4226937",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "+1 848-932-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5850-76de-a0a2-e6e9553ee8f6",
        "storage_key": "property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJKw0kXxHGw4kRn0bEGob21as",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7acd49ac-971e-4516-a5fb-9938792b646e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Middlesex County Open Space",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "691-707 Middlesex Ave, Metuchen, NJ 08840, USA",
      "poi_short_description": "Kid-friendly paved greenway (with a bridge) for walking and biking, as well as roller blading and skating.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-5dbf-706d-9e91-2c74024091f5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-5dbf-706d-9e91-2c74024091f5",
        "storage_key": "property/6767906449166309/019fcdf3-5dbf-706d-9e91-2c74024091f5.webp",
        "width": 1135,
        "height": 1280
      },
      "poi_business_url": "https://www.middlesexcountynj.gov/Home/Components/FacilityDirectory/FacilityDirectory/101/1024",
      "poi_directions_map_url": "https://maps.google.com/?cid=13651701187644498313&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middlesex-county-open-space",
      "poi_latitude": "40.5390333",
      "poi_longitude": "-74.3685028",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 732-985-7071",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5850-76de-a0a2-e6e9553ee8f6",
        "storage_key": "property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCxz69tC3w4kRiSFUfeaVdL0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_58339639-936a-4ae8-82a7-43020cdc467d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Roosevelt Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "151 Parsonage Rd, Edison, NJ 08837, USA",
      "poi_short_description": "Park offering multiple sports areas, trails, lake fishing, an ice skating rink & an outdoor theater.",
      "poi_long_description": "Park offering multiple sports areas, trails, lake fishing, an ice skating rink & an outdoor theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-5ee9-7179-abb4-dc3727217190.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-5ee9-7179-abb4-dc3727217190",
        "storage_key": "property/6767906449166309/019fcdf3-5ee9-7179-abb4-dc3727217190.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.middlesexcountynj.gov/Home/Components/FacilityDirectory/FacilityDirectory/89/",
      "poi_directions_map_url": "https://maps.google.com/?cid=288203184622253265&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "roosevelt-park",
      "poi_latitude": "40.5489003",
      "poi_longitude": "-74.3401403",
      "poi_miles_from_property": "8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 732-745-3900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5850-76de-a0a2-e6e9553ee8f6",
        "storage_key": "property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXa1yg0C2w4kR0bSL-kTn_wM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7bd038d1-a958-4f44-8f23-b03c1e219ee5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Washington Rock State Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16 Rock Rd E, Watchung, NJ 07096, USA",
      "poi_short_description": "This former lookout point during the American Revolution offers dramatic views & picnic areas.",
      "poi_long_description": "This former lookout point during the American Revolution offers dramatic views & picnic areas.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-6455-75e1-96d5-f80e11cdb05b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-6455-75e1-96d5-f80e11cdb05b",
        "storage_key": "property/6767906449166309/019fcdf3-6455-75e1-96d5-f80e11cdb05b.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.nj.gov/dep/parksandforests/parks/washingtonrockstatepark.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=4937616108901422943&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "washington-rock-state-park",
      "poi_latitude": "40.6127525",
      "poi_longitude": "-74.4723817",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 52 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 908-722-1200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5850-76de-a0a2-e6e9553ee8f6",
        "storage_key": "property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJP0BYTGW5w4kRX9dQwLDvhUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_1796fea2-7ae2-4f6a-a03a-4b63721cdfb4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Peter J. Barnes III Wildlife Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Dismal Swamp Preserve, Reading Rd, Edison, NJ 08820, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-6534-7391-a3bf-e9cbac916bec.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-6534-7391-a3bf-e9cbac916bec",
        "storage_key": "property/6767906449166309/019fcdf3-6534-7391-a3bf-e9cbac916bec.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.barnespreservenj.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2638670185570019184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "peter-j-barnes-iii-wildlife-preserve",
      "poi_latitude": "40.5534352",
      "poi_longitude": "-74.3899424",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5850-76de-a0a2-e6e9553ee8f6",
        "storage_key": "property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJGRFDU9m3w4kRcKdQso1wniQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f0182255-b232-4835-8c41-3b883ed375b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Ambrose Doty County Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-64f2-73ab-9232-9fb105b48dad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-64f2-73ab-9232-9fb105b48dad",
        "storage_key": "property/6767906449166309/019fcdf3-64f2-73ab-9232-9fb105b48dad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=9655927024163859700&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ambrose-doty-county-park",
      "poi_latitude": "40.537774",
      "poi_longitude": "-74.43105059999999",
      "poi_miles_from_property": "3.3",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5850-76de-a0a2-e6e9553ee8f6",
        "storage_key": "property/6767906449166309/019d0266-5850-76de-a0a2-e6e9553ee8f6.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJtSZzbIvHw4kR9KxhHHi-AIY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_15454655-3cd4-47d6-bf8c-794c208b1eef",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "New Brunswick",
      "poi_type": "Transportation & Transit",
      "poi_address": "French St &, Albany St, New Brunswick, NJ 08901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-6609-774c-80e8-917461747c81.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-6609-774c-80e8-917461747c81",
        "storage_key": "property/6767906449166309/019fcdf3-6609-774c-80e8-917461747c81.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=NBK",
      "poi_directions_map_url": "https://maps.google.com/?cid=4764075942355430889&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-brunswick",
      "poi_latitude": "40.496654",
      "poi_longitude": "-74.446092",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5ad4-71cb-979c-07f58e936b00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5ad4-71cb-979c-07f58e936b00",
        "storage_key": "property/6767906449166309/019d0266-5ad4-71cb-979c-07f58e936b00.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJOyllH1fGw4kR6W0UE9RlHUI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0da0bfc0-f2d0-4e68-ad31-dc1824f77324",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Jersey Avenue",
      "poi_type": "Transportation & Transit",
      "poi_address": "New Brunswick, NJ 08901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-6b91-77bc-8b47-e36e908c11f0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-6b91-77bc-8b47-e36e908c11f0",
        "storage_key": "property/6767906449166309/019fcdf3-6b91-77bc-8b47-e36e908c11f0.webp",
        "width": 800,
        "height": 600
      },
      "poi_business_url": "http://www.njtransit.com/rg/rg_servlet.srv?hdnPageAction=TrainStationLookupFrom&selStation=32906",
      "poi_directions_map_url": "https://maps.google.com/?cid=2441519463445449231&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "jersey-avenue",
      "poi_latitude": "40.4769397",
      "poi_longitude": "-74.46741759999999",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 34 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "26 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5ad4-71cb-979c-07f58e936b00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5ad4-71cb-979c-07f58e936b00",
        "storage_key": "property/6767906449166309/019d0266-5ad4-71cb-979c-07f58e936b00.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJj9dXipDGw4kRD0reKgQF4iE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_715de80a-6e6f-4ee8-88ef-f1c924572247",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Edison",
      "poi_type": "Transportation & Transit",
      "poi_address": "12 Reed Street, Edison, NJ 08817, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-6b89-7626-8647-d4195f8c231c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-6b89-7626-8647-d4195f8c231c",
        "storage_key": "property/6767906449166309/019fcdf3-6b89-7626-8647-d4195f8c231c.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "http://www.njtransit.com/rg/rg_servlet.srv?hdnPageAction=TrainStationLookupFrom&selStation=38",
      "poi_directions_map_url": "https://maps.google.com/?cid=13917052360090710522&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edison",
      "poi_latitude": "40.5191072",
      "poi_longitude": "-74.41082779999999",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 49 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5ad4-71cb-979c-07f58e936b00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5ad4-71cb-979c-07f58e936b00",
        "storage_key": "property/6767906449166309/019d0266-5ad4-71cb-979c-07f58e936b00.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJ_yVVyODHw4kR-vG3w2JNI8E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5be3b0f4-a660-47b9-b146-f1625c2aa9c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Metropark",
      "poi_type": "Transportation & Transit",
      "poi_address": "100 Middlesex Essex Turnpike, Iselin, NJ 08830, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-6cb1-700d-be6e-4a8a81d87423.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-6cb1-700d-be6e-4a8a81d87423",
        "storage_key": "property/6767906449166309/019fcdf3-6cb1-700d-be6e-4a8a81d87423.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=964550616704292434&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "metropark",
      "poi_latitude": "40.568101",
      "poi_longitude": "-74.3296338",
      "poi_miles_from_property": "7.8",
      "poi_walking_minutes": "2 hours 55 mins",
      "poi_biking_minutes": "42 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5ad4-71cb-979c-07f58e936b00.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5ad4-71cb-979c-07f58e936b00",
        "storage_key": "property/6767906449166309/019d0266-5ad4-71cb-979c-07f58e936b00.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJZcXGiYm2w4kRUhaL7KzFYg0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_bb36bdfb-974d-4c4d-be7e-437684a468d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Newark Liberty International Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "Newark International Airport St, Newark, NJ 07114, USA",
      "poi_short_description": "Opened in 1928, this airport serving the NYC area is the oldest airfield in the United States.",
      "poi_long_description": "Opened in 1928, this airport serving the NYC area is the oldest airfield in the United States.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-6cc9-7016-8279-678272e89d4b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-6cc9-7016-8279-678272e89d4b",
        "storage_key": "property/6767906449166309/019fcdf3-6cc9-7016-8279-678272e89d4b.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.newarkairport.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12966905903765254790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "newark-liberty-international-airport",
      "poi_latitude": "40.6884837",
      "poi_longitude": "-74.17686359999999",
      "poi_miles_from_property": "25.1",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "2 hours 0 mins",
      "poi_driving_minutes": "32 mins",
      "poi_business_phone": "+1 973-961-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5c6e-7798-a8da-8f1a30accbfc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5c6e-7798-a8da-8f1a30accbfc",
        "storage_key": "property/6767906449166309/019d0266-5c6e-7798-a8da-8f1a30accbfc.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7wzsxeFSwokRhvLXxTe087M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_7e1773ac-fd6a-4a31-905e-aa599eeea462",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Coach Usa",
      "poi_type": "Transportation & Transit",
      "poi_address": "750 Somerset St, New Brunswick, NJ 08901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-7174-731e-9797-7c22a0fd74ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-7174-731e-9797-7c22a0fd74ea",
        "storage_key": "property/6767906449166309/019fcdf3-7174-731e-9797-7c22a0fd74ea.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.coachusa.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14131625111476866619&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "coach-usa",
      "poi_latitude": "40.4849097",
      "poi_longitude": "-74.4737962",
      "poi_miles_from_property": "8.9",
      "poi_walking_minutes": "3 hours 20 mins",
      "poi_biking_minutes": "54 mins",
      "poi_driving_minutes": "23 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-522b-70ec-b794-39082eb7e549",
        "storage_key": "property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdQ-DGpXGw4kRO46RlCqeHcQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_534c2072-fbe8-4f95-9209-28ac2af831f1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Neilson Plaza",
      "poi_type": "Transportation & Transit",
      "poi_address": "200 Naricon Pl, East Brunswick, NJ 08816, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=8020852167320451691&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "neilson-plaza",
      "poi_latitude": "40.4813538",
      "poi_longitude": "-74.4104252",
      "poi_miles_from_property": "9.5",
      "poi_walking_minutes": "3 hours 33 mins",
      "poi_biking_minutes": "1 hour 6 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5c78-709a-8a62-11b4bb99c345.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5c78-709a-8a62-11b4bb99c345",
        "storage_key": "property/6767906449166309/019d0266-5c78-709a-8a62-11b4bb99c345.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJVVVVaSHGw4kRa7oOxYzKT28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_5ecee57a-f824-444e-b56e-3daf2df83b5e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Rutgers University Busch Student Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "604 Bartholomew Rd Suite 152, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-71bd-77da-bed6-86101e502eef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-71bd-77da-bed6-86101e502eef",
        "storage_key": "property/6767906449166309/019fcdf3-71bd-77da-bed6-86101e502eef.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://sca.rutgers.edu/student-centers/our-centers/busch-student-center",
      "poi_directions_map_url": "https://maps.google.com/?cid=17120345248572064084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rutgers-university-busch-student-center",
      "poi_latitude": "40.5233281",
      "poi_longitude": "-74.45828209999999",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 56 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 848-445-4724",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5206-73f5-8bf5-59d787c50a38",
        "storage_key": "property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ28GRkwvHw4kRVEEvzUuvl-0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_361c1a10-dfd9-48e6-8f17-2fa0d51b35a6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "New Jersey Turnpike",
      "poi_type": "Transportation & Transit",
      "poi_address": "New Jersey Turnpike, New Jersey, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-7342-737a-bf6a-2656e63ec870.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-7342-737a-bf6a-2656e63ec870",
        "storage_key": "property/6767906449166309/019fcdf3-7342-737a-bf6a-2656e63ec870.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=14229653371534854247&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "new-jersey-turnpike",
      "poi_latitude": "40.7565413",
      "poi_longitude": "-74.1029642",
      "poi_miles_from_property": "26.2",
      "poi_walking_minutes": "9 hours 42 mins",
      "poi_biking_minutes": "2 hours 56 mins",
      "poi_driving_minutes": "43 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-522b-70ec-b794-39082eb7e549",
        "storage_key": "property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Z_wV2Hiw4kRZ0hGd1niecU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_93a5e5ad-98ce-499c-ace4-f57db244d2a7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Johnson & Johnson WHQ",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Johnson And Johnson Plaza, New Brunswick, NJ 08933, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-7480-74db-9925-694d11ea0ed7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-7480-74db-9925-694d11ea0ed7",
        "storage_key": "property/6767906449166309/019fcdf3-7480-74db-9925-694d11ea0ed7.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.jnj.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2409051668536351912&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "johnson--johnson-whq",
      "poi_latitude": "40.4979551",
      "poi_longitude": "-74.4430644",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 46 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 732-524-2455",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-522b-70ec-b794-39082eb7e549",
        "storage_key": "property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJqSy5l0gPZkARqNyrlLqrbiE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_f3141294-b0ec-457c-984a-4a7df5ccd87a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Rutgers University–New Brunswick",
      "poi_type": "Major Employers & Offices",
      "poi_address": "New Brunswick, NJ, USA",
      "poi_short_description": "Flagship campus of a research university founded in 1766 known for its many graduate programs.",
      "poi_long_description": "Flagship campus of a research university founded in 1766 known for its many graduate programs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-787c-776d-9eca-9720e076ef7a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-787c-776d-9eca-9720e076ef7a",
        "storage_key": "property/6767906449166309/019fcdf3-787c-776d-9eca-9720e076ef7a.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://newbrunswick.rutgers.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5887366237779570504&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rutgers-universitynew-brunswick",
      "poi_latitude": "40.5037764",
      "poi_longitude": "-74.4508342",
      "poi_miles_from_property": "6.9",
      "poi_walking_minutes": "2 hours 35 mins",
      "poi_biking_minutes": "40 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 848-445-4636",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5206-73f5-8bf5-59d787c50a38",
        "storage_key": "property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJvwa-GFXGw4kRSK96kWYgtFE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a8f53848-0c05-4d5a-a7cf-a9eccc65cac6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Robert Wood Johnson University Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1 Robert Wood Johnson Pl, New Brunswick, NJ 08901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-4892-723e-9ae7-22d3d3f208a8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-4892-723e-9ae7-22d3d3f208a8",
        "storage_key": "property/6767906449166309/019fcdf3-4892-723e-9ae7-22d3d3f208a8.webp",
        "width": 959,
        "height": 723
      },
      "poi_business_url": "https://www.rwjbh.org/rwj-university-hospital-new-brunswick/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5260900183843214550&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robert-wood-johnson-university-hospital",
      "poi_latitude": "40.4951556",
      "poi_longitude": "-74.4500083",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 732-828-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5859-77bb-82b5-7e02e9aef182.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5859-77bb-82b5-7e02e9aef182",
        "storage_key": "property/6767906449166309/019d0266-5859-77bb-82b5-7e02e9aef182.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJLXT741bGw4kR1hTDANh4Akk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4fd8b325-8bbd-4c89-bace-6c766b7bba57",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Rutgers, Robert Wood Johnson Medical School - Piscataway Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "675 Hoes Ln W, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://rwjms.rutgers.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16224897955703117754&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rutgers-robert-wood-johnson-medical-school---piscataway-campus",
      "poi_latitude": "40.5241785",
      "poi_longitude": "-74.4697384",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 800-443-8211",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5206-73f5-8bf5-59d787c50a38",
        "storage_key": "property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJTSn4kQ_Hw4kRulelPrpqKuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_9a0bb249-9f58-441d-9f31-3de68af77714",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Rutgers Business School - New Brunswick",
      "poi_type": "Major Employers & Offices",
      "poi_address": "100 Rockafeller Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-795c-77ae-9b0d-346c7ff724dc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-795c-77ae-9b0d-346c7ff724dc",
        "storage_key": "property/6767906449166309/019fcdf3-795c-77ae-9b0d-346c7ff724dc.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.business.rutgers.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4839273164358640101&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rutgers-business-school---new-brunswick",
      "poi_latitude": "40.5234803",
      "poi_longitude": "-74.4405456",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 848-445-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5206-73f5-8bf5-59d787c50a38",
        "storage_key": "property/6767906449166309/019d0266-5206-73f5-8bf5-59d787c50a38.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJi23LuOTHw4kR5WGtrE2NKEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_573979d5-71bb-4e98-8a4a-e1020e9b3ab5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Life Sciences Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "Life Sciences Building, 145 Bevier Rd, Piscataway, NJ 08854, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=12047709289689903898&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "life-sciences-building",
      "poi_latitude": "40.5244535",
      "poi_longitude": "-74.4634581",
      "poi_miles_from_property": "5.5",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-522b-70ec-b794-39082eb7e549",
        "storage_key": "property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJG0BOTg3Hw4kRGvMjecQPMqc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8ac5db60-071f-43d3-8563-56123067adae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Rutgers Cancer Institute",
      "poi_type": "Major Employers & Offices",
      "poi_address": "195 Little Albany St, New Brunswick, NJ 08901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-79bc-76af-8a01-763e42517b16.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-79bc-76af-8a01-763e42517b16",
        "storage_key": "property/6767906449166309/019fcdf3-79bc-76af-8a01-763e42517b16.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://cinj.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9008217331451425640&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rutgers-cancer-institute",
      "poi_latitude": "40.4964331",
      "poi_longitude": "-74.4487144",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 51 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 732-235-2465",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-522b-70ec-b794-39082eb7e549",
        "storage_key": "property/6767906449166309/019d0266-522b-70ec-b794-39082eb7e549.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJgfJE7lbGw4kRaPOtdO-dA30",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_009f2227-bda9-4449-9a7a-288e0ebdea5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "The Bristol-Myers Squibb Children's Hospital at Robert Wood Johnson University Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "200 Somerset St, New Brunswick, NJ 08901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-7ce8-72dc-a685-88ad6c490c71.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-7ce8-72dc-a685-88ad6c490c71",
        "storage_key": "property/6767906449166309/019fcdf3-7ce8-72dc-a685-88ad6c490c71.webp",
        "width": 1280,
        "height": 959
      },
      "poi_business_url": "https://www.rwjbh.org/bristol-myers-squibb-childrens-hospital-at-rwjuh/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8792253750343300341&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-bristol-myers-squibb-childrens-hospital-at-robert-wood-johnson-university-hospital",
      "poi_latitude": "40.4948553",
      "poi_longitude": "-74.4515552",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 732-828-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5859-77bb-82b5-7e02e9aef182.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5859-77bb-82b5-7e02e9aef182",
        "storage_key": "property/6767906449166309/019d0266-5859-77bb-82b5-7e02e9aef182.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJy9EoZzfHw4kR9fRO3DNcBHo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a4dc7068-c188-487c-9a63-967b35121274",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Saint Peter's University Hospital",
      "poi_type": "Major Employers & Offices",
      "poi_address": "254 Easton Ave, New Brunswick, NJ 08901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-7f7e-740e-91ac-2a0f2549dcdd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-7f7e-740e-91ac-2a0f2549dcdd",
        "storage_key": "property/6767906449166309/019fcdf3-7f7e-740e-91ac-2a0f2549dcdd.webp",
        "width": 1100,
        "height": 732
      },
      "poi_business_url": "https://www.saintpetershcs.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3638924045633232080&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "saint-peters-university-hospital",
      "poi_latitude": "40.50068890000001",
      "poi_longitude": "-74.45942",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 45 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 732-745-8600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019d0266-5859-77bb-82b5-7e02e9aef182.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d0266-5859-77bb-82b5-7e02e9aef182",
        "storage_key": "property/6767906449166309/019d0266-5859-77bb-82b5-7e02e9aef182.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJFZSRMPzGw4kR0JyYwCMOgDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0f00485e-5dff-4cbb-8d49-0d58bfd4fd04",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "poi_name": "Middlesex - County Administration Building",
      "poi_type": "Major Employers & Offices",
      "poi_address": "75 Bayard St, New Brunswick, NJ 08901, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-7f90-766a-85f7-a0c965889775.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fcdf3-7f90-766a-85f7-a0c965889775",
        "storage_key": "property/6767906449166309/019fcdf3-7f90-766a-85f7-a0c965889775.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.middlesexcountynj.gov/Government/Directory/Pages/Directions/Admin%20Building%20Directions.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=18294512990454448586&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "middlesex---county-administration-building",
      "poi_latitude": "40.494222",
      "poi_longitude": "-74.4462341",
      "poi_miles_from_property": "7.7",
      "poi_walking_minutes": "2 hours 50 mins",
      "poi_biking_minutes": "46 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 732-745-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019fcdf3-8abc-76bb-ab40-84f750008d24.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fcdf3-8abc-76bb-ab40-84f750008d24",
        "storage_key": "property/6767906449166309/019fcdf3-8abc-76bb-ab40-84f750008d24.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJNYMMyVDGw4kRyoHO5qIq4_0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "custom_6da5bfea-26a9-4bbe-994d-73a61f0b1fb3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f9fa2295-2f60-4525-8a1b-634ded341d3e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_f2fd6329-67f6-4d4e-8ebd-fb23e8c41da6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_73885278-94cc-4823-bdbd-99777b57fff3",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_ffbedb51-9db7-40c6-860b-771c799c4820",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_3744083c-e9f1-4a00-ab8c-860314ad1dd2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_1f020623-9120-449a-9ab7-e9e05a869a15",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "rating": "5.0",
      "name": "Food Lover",
      "text": "We like the apartments and have a beautiful view of our patio.\n\nThanks to ASPEN Team especially Ms. Katrina,Mr.Toney,Super help full Stevenson & Mr.Josh\nI am editing my  old review!! We moved here back in June 2020,it’s our 2nd lease and we are planing to renew it again!!\n\nThey have great maintenance team we had issues from refrigerator to water heat A/C to carpet cleaning and other small maintenance issues,they always help as quickly as possible.\n\nWe love our patio view and can not compare this with any other place if we move out…it’s our home not just an apartment.\n\nThanks to Aspen CT team for their priceless efforts!!",
      "date": "2022-04-28",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_76f7bcd6-cc78-47d1-8905-3cdd882f6b2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/019f8fa7-86a4-70ff-8a50-4e51e5119bd5.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019f8fa7-86a4-70ff-8a50-4e51e5119bd5",
        "storage_key": "property/6767906449166309/019f8fa7-86a4-70ff-8a50-4e51e5119bd5.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "2Bd | 2Ba + Den",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=62e44b3392728e11543e59c6&sourceId=1001"
    }
  ],
  "faqs": [],
  "fees": [
    {
      "id": "ec_e71992c8f483a9f7e2ac3349",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "429395",
      "name": "Amenity Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_c75bf5b65979d3c95ed26133",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "429396",
      "name": "Application Fee",
      "description": "Per applicant.",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_ae550bc39c6df8a45f76e535",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "429397",
      "name": "Security Deposit",
      "description": "Deposit amount applies with approved credit and may be higher for conditional approvals.",
      "amount": 750,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": true,
      "is_taxable": false
    },
    {
      "id": "ec_f1f76098566e359b6d378bdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "429398",
      "name": "Pet Fee",
      "description": "One-time fee of $350 covers up to 2 pets.",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_7bdac8261e36e29834d44f8a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "429400",
      "name": "Pet Rent",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "pets_other",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_20a15329165401f76f68c87b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "429402",
      "name": "Reservation Fee",
      "description": "false",
      "amount": 200,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at application",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_85cb343dbce1fe1c8ce4ed24",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "429403",
      "name": "Month To Month Fee",
      "description": "false",
      "amount": 350,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_f999a3e49962b774addf8d69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "429404",
      "name": "Storage Space",
      "description": "false",
      "amount": 130,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "storage",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_e76c0eab7dc4c3773a946c69",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "429405",
      "name": "Transfer Fee",
      "description": "false",
      "amount": 500,
      "amount_max": 1000,
      "amount_raw": "false",
      "amount_type": "range",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_63fdd8097697ea5d4a75f1c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "429409",
      "name": "Trash Service",
      "description": "false",
      "amount": 12,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_cc323481e1299dec87b44a5a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "536733",
      "name": "Utility - Administrative Billing Fee",
      "description": "false",
      "amount": 5,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_34c0de25c23ffc3bd1e91e96",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "543084",
      "name": "Utility - Gas Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_385628bf054c4a30c6a4c250",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "543085",
      "name": "Utility - Water/Sewer Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_2c8a159338e6a89a81c5cb2b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "543086",
      "name": "Utility - Electric Service",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "Usage-Based (Utilities)",
      "amount_type": "text",
      "timing": "Monthly, due at move-in",
      "category": "utilities",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1e617ccb56459f908c1d11e7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "835195",
      "name": "Lockout Fee - After Hours",
      "description": "false",
      "amount": 75,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_1bf3035dbd9e266adff39386",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "835197",
      "name": "NSF/Returned Check Fee",
      "description": "false",
      "amount": 50,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Per occurrence",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_430ea629c943eeb0160f8381",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "838626",
      "name": "Certificate of Occupancy Fee",
      "description": "false",
      "amount": 100,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "One-time, due at move-in",
      "category": "contracting",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_9462c9f216976f7ca6ee6989",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "838627",
      "name": "Buy-Out Fee",
      "description": "false",
      "amount": 0,
      "amount_max": 0,
      "amount_raw": "One Month's Rent",
      "amount_type": "text",
      "timing": "One-time",
      "category": "contracting",
      "charge_code": "false",
      "is_required": false,
      "is_refundable": false,
      "is_taxable": false
    },
    {
      "id": "ec_4ff8134e824a81e69e4c8cac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "engrain",
      "external_id": "838629",
      "name": "Amenity Fee - Renewal",
      "description": "false",
      "amount": 250,
      "amount_max": 0,
      "amount_raw": "false",
      "amount_type": "fixed",
      "timing": "Annually, due at move-in",
      "category": "community",
      "charge_code": "false",
      "is_required": true,
      "is_refundable": false,
      "is_taxable": false
    }
  ],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a1227-c0f3-74ef-8042-66db3f9b037d",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "aion-aspen-court-apartment-homes",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309"
    },
    {
      "lead_collector_id": "019c3043-28a7-766e-80a9-91f8f1650530",
      "lead_source": "FACEBOOK_ADS",
      "name": "aspen-court-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309"
    },
    {
      "lead_collector_id": "019c3043-2915-73d9-b84a-9fe599792f9e",
      "lead_source": "LANDING_PAGE",
      "name": "aspen-court-apartments",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "pet-friendly-apartments-piscataway-nj-149",
      "search_query": "pet friendly apartments Piscataway NJ",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Piscataway, NJ",
      "h2_subtitle": "Discover welcoming pet-friendly apartments at Aspen Court. Enjoy the perfect home in Piscataway, NJ, where your furry friends are welcome.",
      "page_copy": "Welcome to Aspen Court Apartment Homes, where our pet-friendly apartments in Piscataway, NJ, provide a haven for you and your four-legged companions. Our spacious one and two-bedroom floor plans are thoughtfully designed to create a comfortable living environment for both you and your pets. Take leisurely strolls with your furry friend along our serene walking trails and socialize at our vibrant clubhouse.\n\nAt Aspen Court, we understand that pets are part of the family. Our community offers an exceptional amenity experience with expansive sundecks perfect for soaking up the sun, and a refreshing swimming pool to cool off. With easy access to I-287, explore nearby pet-friendly parks and attractions in Piscataway. Experience the best in convenience and pet-friendly living at Aspen Court Apartment Homes today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Piscataway, NJ",
      "seo_description": "Find your ideal pet-friendly apartment in Piscataway, NJ at Aspen Court. Enjoy spacious living, modern amenities, and convenience all in one place.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "apartments-swimming-pool-middlesex-county-507",
      "search_query": "apartments with swimming pool Middlesex County",
      "category": "Amenity",
      "h1_title": "Apartments with Swimming Pool in Middlesex County",
      "h2_subtitle": "Explore best-in-class apartments with a swimming pool in Middlesex County. Enjoy luxury living at Aspen Court Apartment Homes, featuring first-rate amenities.",
      "page_copy": "Aspen Court Apartment Homes in Middlesex County offers the ideal setting for those searching for apartments with a swimming pool. Our community in Piscataway, NJ, features a refreshing swimming pool that's perfect for both relaxation and recreation. Dive into luxury with additional amenities including a vibrant clubhouse and expansive sundecks.\n\nOur modern one and two-bedroom apartments are designed with comfort in mind, complete with chic finishes and contemporary kitchens. Enjoy the convenience of our prime location near I-287 and discover a welcoming home at Aspen Court. Whether you want to lounge by the pool or take a dip, our community is equipped to offer the lifestyle you deserve. Experience unparalleled convenience and leisure at Aspen Court Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apts with Swimming Pool in Middlesex County",
      "seo_description": "Find top apartments with a swimming pool in Middlesex County at Aspen Court. Experience luxury living with modern amenities in Piscataway, NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "in-unit-washer-dryer-apartments-08854-728",
      "search_query": "in-unit washer and dryer apartments 08854",
      "category": "Amenity",
      "h1_title": "In-Unit Washer & Dryer Apartments in 08854",
      "h2_subtitle": "Discover the convenience of in-unit washer and dryer apartments in the 08854 area. Aspen Court in Piscataway has everything to ease your lifestyle.",
      "page_copy": "Aspen Court Apartment Homes, located in the 08854 area of Piscataway, NJ, offers in-unit washer and dryer apartments designed for modern living. Enjoy the ultimate convenience of doing laundry in the comfort of your own home without the hassle of community laundry rooms or laundromats. Our spacious one and two-bedroom units provide a perfect blend of style and function.\n\nExperience exceptional amenities like a refreshing swimming pool, expansive sundecks, and a vibrant clubhouse, all within our pet-friendly community. With quick access to I-287 and Middlesex County's attractions, Aspen Court is the ideal place to elevate your living experience. Discover the perfect blend of convenience and comfort with our in-unit washer and dryer feature, making life easier at Aspen Court in Piscataway.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "In-Unit Washer & Dryer Apts in 08854",
      "seo_description": "Find in-unit washer and dryer apartments in the 08854 area at Aspen Court. Experience comfort and convenience in Piscataway, NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "dog-park-apartments-near-i-287-674",
      "search_query": "dog park apartments near I-287",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments Near I-287",
      "h2_subtitle": "Discover dog park apartments near I-287 at Aspen Court. Enjoy a pet-friendly community with convenient amenities in Piscataway, NJ.",
      "page_copy": "At Aspen Court Apartment Homes in Piscataway, NJ, we offer dog park apartments near I-287, providing an ideal home for you and your pets. Our pet-friendly community not only welcomes your furry friends but also boasts serene walking trails perfect for daily walks. This is an excellent place for pet lovers seeking a blend of comfort and location.\n\nPositioned conveniently close to I-287, Aspen Court provides easy access to local attractions and outdoor spaces. Enjoy modern one and two-bedroom apartments that suit your lifestyle, alongside amenities like a refreshing swimming pool and vibrant clubhouse. Experience the benefits of living in a community where both you and your pets are at the heart of everything we offer. Make Aspen Court your pet-friendly home today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park Apartments Near I-287",
      "seo_description": "Discover pet-friendly living near I-287 at Aspen Court. Enjoy our dog park apartments in Piscataway, NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "air-conditioned-luxury-apts-piscataway-86",
      "search_query": "air conditioned luxury apartments Piscataway",
      "category": "Amenity",
      "h1_title": "Air Conditioned Luxury Apartments in Piscataway",
      "h2_subtitle": "Experience air conditioned luxury apartments at Aspen Court in Piscataway. Enjoy modern comforts and upscale amenities in our vibrant community.",
      "page_copy": "Aspen Court Apartment Homes offers air conditioned luxury apartments in the heart of Piscataway, NJ. Our spacious one and two-bedroom floor plans come equipped with modern kitchens, chic finishes, and, importantly, air conditioning to ensure optimal comfort year-round. These stylish apartments provide the perfect retreat from the bustling city life.\n\nOur community is designed with luxury in mind, featuring upscale amenities like a refreshing swimming pool and expansive sundecks. Located conveniently near I-287, Aspen Court provides easy access to the best of Piscataway and Middlesex County. Elevate your lifestyle by choosing an apartment that combines modern comforts with prime location—embrace refined living at Aspen Court Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Luxury Apts in Piscataway",
      "seo_description": "Discover air conditioned luxury apartments in Piscataway at Aspen Court. Enjoy modern living with top amenities in NJ.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "one-bedroom-apartments-piscataway-nj-746",
      "search_query": "one bedroom apartments piscataway nj",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in Piscataway, NJ",
      "h2_subtitle": "Explore one bedroom apartments at Aspen Court in Piscataway, NJ. Experience comfort and convenience in our modern, pet-friendly community.",
      "page_copy": "Aspen Court Apartment Homes in Piscataway, NJ, offers beautifully designed one bedroom apartments that perfectly blend comfort and convenience. Each apartment features a modern kitchen, chic finishes, and spacious layouts that cater to your lifestyle needs. Whether you're starting a new chapter or need a cozy space to call home, our one bedroom units provide the ideal living environment.\n\nLocated in a prime spot near I-287, our community ensures easy access to local attractions and services. Enjoy a suite of amenities that includes a refreshing swimming pool, expansive sundecks with lounge chairs, and a vibrant clubhouse. Aspen Court creates a welcoming setting for residents and their pets, making it an exceptional choice for those seeking one bedroom apartments in Piscataway, NJ.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "One Bedroom Apartments in Piscataway, NJ",
      "seo_description": "Find your perfect one bedroom apartment at Aspen Court in Piscataway, NJ. Enjoy modern facilities and a pet-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "two-bedroom-apartments-middlesex-county-784",
      "search_query": "two bedroom apartments middlesex county",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Middlesex County",
      "h2_subtitle": "Discover two bedroom apartments at Aspen Court in Middlesex County. Experience spacious living and premium amenities in a prime location.",
      "page_copy": "At Aspen Court Apartment Homes, we pride ourselves on offering spacious two bedroom apartments in Middlesex County that cater to modern living needs. Each apartment comes with contemporary kitchens and sleek finishes, providing a comfortable and stylish home. Whether it's for a growing family or sharing with a roommate, our two-bedroom layouts offer ample space and flexibility.\n\nNestled in the thriving community of Piscataway, NJ, Aspen Court provides convenient access to I-287, making it easy to explore all that Middlesex County offers. Residents enjoy premium amenities, including a refreshing swimming pool, an on-site game room, and serene walking trails within our pet-friendly community. Experience elevated living in a location that brings everything you need right to your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Two Bedroom Apartments in Middlesex County",
      "seo_description": "Explore two bedroom apartments at Aspen Court in Middlesex County. Enjoy spacious living and top amenities in a prime NJ location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "apartments-near-piscataway-high-school-nj-79",
      "search_query": "apartments near Piscataway High School NJ",
      "category": "School",
      "h1_title": "Apartments Near Piscataway High School, NJ",
      "h2_subtitle": "Discover the convenience of living near Piscataway High School. Aspen Court offers modern apartments just minutes away in a vibrant community.",
      "page_copy": "Aspen Court Apartment Homes provides the perfect solution for those seeking apartments near Piscataway High School, NJ. Our modern community combines convenience with style, offering spacious one and two-bedroom layouts equipped with chic finishes and modern kitchens. Located in Piscataway, NJ, our apartments provide easy access to the high school, making daily commutes a breeze.\n\nBeyond proximity to education, residents enjoy a host of amenities designed to enhance their living experience. From a refreshing swimming pool to a vibrant clubhouse and serene walking trails, our community is crafted to balance fun and relaxation. Moreover, with our convenient location near I-287, all of Piscataway and Middlesex County is within easy reach. Choose Aspen Court for a lifestyle that prioritizes both comfort and accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Piscataway High School, NJ",
      "seo_description": "Find modern apartments minutes from Piscataway High School, NJ at Aspen Court. Enjoy convenience and a vibrant community lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "aspen-court-near-quibbletown-middle-school-42",
      "search_query": "Aspen Court apartments close to Quibbletown Middle School",
      "category": "School",
      "h1_title": "Aspen Court Apartments Near Quibbletown MS",
      "h2_subtitle": "Conveniently located near Quibbletown Middle School, Aspen Court offers modern living in a friendly community.",
      "page_copy": "Aspen Court Apartment Homes in Piscataway, NJ, is ideally situated for families and students seeking proximity to Quibbletown Middle School. Our modern and comfortable apartments are just a short distance away, ensuring that school drop-offs and pickups are hassle-free. Choose from spacious one and two-bedroom floor plans, each featuring modern kitchens and elegant finishes, providing a cozy and functional living environment.\n\nLiving at Aspen Court also means access to a plethora of exclusive amenities designed for relaxation and recreation. Dive into our refreshing swimming pool, enjoy the expansive sundeck with lounge chairs, or take a leisurely stroll on our serene walking trails. Conveniently located near major highways, our pet-friendly community makes it easy to enjoy all the conveniences and attractions of Middlesex County. Experience the perfect blend of location and lifestyle at Aspen Court.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Aspen Court Apts Near Quibbletown Middle School",
      "seo_description": "Live close to Quibbletown Middle School at Aspen Court. Discover modern apartments and family-friendly amenities in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "middlesex-county-apartments-near-conackamack-ms-998",
      "search_query": "Middlesex County apartments near Conackamack Middle School",
      "category": "School",
      "h1_title": "Middlesex County Apartments Near Conackamack MS",
      "h2_subtitle": "Find ideal living solutions in Middlesex County, close to Conackamack Middle School. Aspen Court offers convenience and comfort.",
      "page_copy": "Aspen Court Apartment Homes proudly provides an exceptional living experience in Middlesex County, conveniently located near Conackamack Middle School. Our community offers spacious one and two-bedroom apartments featuring modern designs and finishes ideal for comfortable family living. With our close proximity to the school, daily routines are made easier, offering parents and students the convenience they need.\n\nResidents at Aspen Court enjoy a host of premium amenities, from a refreshing swimming pool and game room to scenic walking trails perfect for a leisurely escape. Located in the vibrant community of Piscataway, our pet-friendly residences are just minutes from major highways, offering easy access around Middlesex County. Experience an enriching living environment where quality, comfort, and location unite at Aspen Court Apartment Homes.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Conackamack MS, Middlesex County",
      "seo_description": "Discover apartments in Middlesex County near Conackamack Middle School. Enjoy modern living at Aspen Court with top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "apartments-near-theodore-schor-middle-school-859",
      "search_query": "apartments close to Theodore Schor Middle School Piscataway",
      "category": "School",
      "h1_title": "Apartments Near Theodore Schor Middle School",
      "h2_subtitle": "Explore convenient living near Theodore Schor Middle School. Aspen Court offers modern amenities in a prime Piscataway location.",
      "page_copy": "Aspen Court Apartment Homes in Piscataway, NJ, presents the ideal living environment for families seeking apartments close to Theodore Schor Middle School. Our community features spacious one and two-bedroom apartments, blending modern style with practical functionality, making them perfect for families who prioritize educational proximity and convenience.\n\nBeyond its strategic location, Aspen Court boasts a range of exceptional amenities tailored to enhance our residents' lifestyle. Enjoy the refreshing swimming pool, expansive sundeck, and the vibrant clubhouse, all set in a pet-friendly community. With our location near I-287, the rest of Piscataway and neighboring areas are easily accessible, offering both peace and connectivity. Choose Aspen Court Apartment Homes, where quality living and convenience meet.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Theodore Schor MS, Piscataway",
      "seo_description": "Find modern apartments in Piscataway close to Theodore Schor Middle School. Enjoy the perfect mix of convenience and amenities at Aspen Court.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "apartments-near-martin-luther-king-intermediate-685",
      "search_query": "apartments by Martin Luther King Intermediate School Middlesex",
      "category": "School",
      "h1_title": "Apartments Near Martin Luther King Intermediate",
      "h2_subtitle": "Discover modern living near Martin Luther King Intermediate School in Middlesex. Aspen Court offers convenience and comfort.",
      "page_copy": "Nestled in the vibrant community of Piscataway, NJ, Aspen Court Apartment Homes provides the perfect location for families looking for apartments by Martin Luther King Intermediate School in Middlesex. Our spacious one and two-bedroom floor plans offer modern kitchens and stylish finishes, creating a home that is both practical and aesthetically pleasing, just a short distance from the school.\n\nResidents at Aspen Court enjoy a wealth of amenities designed to enhance their living experience. From a relaxing pool and expansive sundeck with lounge chairs to serene walking trails, our community invites you to unwind and enjoy the finer things in life. With convenient access to major highways, getting around Middlesex County is a breeze, making Aspen Court not just a home, but a lifestyle choice. Experience the best of location and living at Aspen Court.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Martin Luther King Intermediate",
      "seo_description": "Explore comfortable living near Martin Luther King Intermediate School in Middlesex. Enjoy exceptional amenities at Aspen Court Apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "aspen-court-rentals-near-arbor-intermediate-school-562",
      "search_query": "Aspen Court rentals near Arbor Intermediate School",
      "category": "School",
      "h1_title": "Aspen Court Rentals Near Arbor Intermediate",
      "h2_subtitle": "Experience quality living at Aspen Court, conveniently located near Arbor Intermediate School. Discover spacious rentals today.",
      "page_copy": "Aspen Court Apartment Homes in Piscataway, NJ, offers the perfect solution for families seeking rentals near Arbor Intermediate School. Our spacious one and two-bedroom rentals are designed with modern amenities and chic finishes, providing comfort and style just minutes from the school.\n\nAt Aspen Court, residents enjoy a host of top-tier amenities, enhancing their living experience. Relax by the refreshing swimming pool, socialize in the vibrant clubhouse, or explore serene walking trails, all within a pet-friendly community. Located near major highways, our rentals offer easy access to the heart of Piscataway and beyond. Choose Aspen Court Apartment Homes for a blend of location, convenience, and excellent amenities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Aspen Court Rentals Near Arbor Intermediate",
      "seo_description": "Discover rentals at Aspen Court, near Arbor Intermediate School. Enjoy modern living spaces and exceptional amenities in Piscataway.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "piscataway-apartments-near-knollwood-elementary-493",
      "search_query": "Piscataway NJ apartments near Knollwood Elementary School",
      "category": "School",
      "h1_title": "Apartments Near Knollwood Elementary School",
      "h2_subtitle": "Find top-notch apartments in Piscataway, NJ, near Knollwood Elementary School. Aspen Court offers a welcoming community and modern conveniences.",
      "page_copy": "Aspen Court Apartment Homes is the perfect choice for families searching for Piscataway, NJ apartments near Knollwood Elementary School. Our one and two-bedroom apartments feature contemporary kitchens and chic finishes, making them an inviting home close to the educational excellence of Knollwood Elementary.\n\nLiving at Aspen Court means enjoying a wonderful array of amenities, including a refreshing swimming pool, expansive sundeck, and a lively clubhouse, all surrounded by lush landscapes. Our location offers quick access to I-287, ensuring an easy commute throughout Middlesex County. Whether you’re looking for proximity to schools or a vibrant community atmosphere, Aspen Court Apartment Homes provides the ideal living environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Knollwood Elementary School",
      "seo_description": "Explore Aspen Court's modern apartments in Piscataway, NJ, near Knollwood Elementary. Enjoy superb amenities and a convenient location.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "middlesex-rentals-near-randolphville-elementary-798",
      "search_query": "Middlesex County rentals close to Randolphville Elementary School",
      "category": "School",
      "h1_title": "Rentals Near Randolphville Elementary School",
      "h2_subtitle": "Locate Middlesex County rentals close to Randolphville Elementary School at Aspen Court. Experience comfort and convenience with our premium amenities.",
      "page_copy": "Aspen Court Apartment Homes offers an unmatched living experience with rentals in Middlesex County close to Randolphville Elementary School. Our thoughtfully designed one and two-bedroom apartments provide the perfect setting for families, featuring modern kitchens and elegant finishes in a community dedicated to convenience.\n\nResidents at Aspen Court can unwind with premium amenities like a relaxing swimming pool, a comprehensive sundeck, and beautiful walking trails. Experience the ease of access to major highways, making commutes around Piscataway seamless. Choose Aspen Court for a blend of proximity, lifestyle, and community where every detail is curated for an enhanced living experience near Randolphville Elementary.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Randolphville Elementary School",
      "seo_description": "Discover Aspen Court's rentals in Middlesex County, close to Randolphville Elementary. Enjoy modern amenities and a prime location in Piscataway.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "apartments-near-robert-wood-johnson-piscataway-485",
      "search_query": "apartments near Robert Wood Johnson University Hospital Piscataway",
      "category": "Hospital",
      "h1_title": "Apartments Near Robert Wood Johnson Hospital",
      "h2_subtitle": "Explore spacious apartments in Piscataway close to Robert Wood Johnson University Hospital. Aspen Court offers comfort with convenient access.",
      "page_copy": "Located in the heart of Piscataway, Aspen Court Apartment Homes provides an ideal living environment near Robert Wood Johnson University Hospital. Our community offers spacious one and two-bedroom apartments featuring contemporary designs and modern finishes, making them perfect for those seeking a comfortable home near this renowned medical facility.\n\nResidents appreciate our expansive amenity offerings, which include a tranquil swimming pool, clubhouse, and game room. Located near I-287, commuting is a breeze, adding convenience to the list of benefits. Choose Aspen Court Apartment Homes for unparalleled comfort, style, and proximity to Robert Wood Johnson University Hospital and other local conveniences.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Robert Wood Johnson Hospital",
      "seo_description": "Find ideal apartments at Aspen Court, near Robert Wood Johnson University Hospital in Piscataway. Enjoy modern amenities with easy access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "apartments-near-johnson-park-piscataway-nj-987",
      "search_query": "apartments near Johnson Park Piscataway NJ",
      "category": "Park",
      "h1_title": "Apartments Near Johnson Park, Piscataway NJ",
      "h2_subtitle": "Discover ideal apartments in Piscataway, NJ, near Johnson Park. Aspen Court offers modern living with access to wonderful park facilities.",
      "page_copy": "Aspen Court Apartment Homes, nestled in Piscataway, NJ, is the perfect locale for those seeking apartments near the scenic Johnson Park. Our community offers spacious one and two-bedroom layouts, thoughtfully designed with modern kitchens and chic finishes, providing a perfect blend of style and practicality.\n\nExperience the best of both indoor and outdoor living with our array of amenities, including a refreshing swimming pool and serene walking trails. Being close to Johnson Park means you can enjoy nature walks, sports fields, and picnics just minutes from home. At Aspen Court, benefit from both the tranquility of park-side living and the convenience of city life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Johnson Park, Piscataway NJ",
      "seo_description": "Explore Aspen Court's stylish apartments near Johnson Park in Piscataway, NJ. Enjoy modern amenities and easy park access for outdoor recreation.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "living-close-to-donaldson-park-middlesex-county-812",
      "search_query": "living close to Donaldson Park Middlesex County",
      "category": "Park",
      "h1_title": "Living Close to Donaldson Park",
      "h2_subtitle": "Discover the perks of living close to Donaldson Park in Middlesex County at Aspen Court. Enjoy a blend of comfort and outdoor activities.",
      "page_copy": "Aspen Court Apartment Homes offers a unique blend of suburban tranquillity and urban convenience, ideal for those looking for living close to Donaldson Park in Middlesex County. Our welcoming community features spacious one and two-bedroom apartments designed with modern finishes and stylish amenities that suit any lifestyle.\n\nLiving here means access to a host of excellent facilities, including a refreshing swimming pool and picturesque walking trails. Enjoy the proximity to Donaldson Park, where residents can indulge in leisurely strolls, picnics, and various recreational activities. Aspen Court not only provides a wonderful living space but also the convenience of being near beautiful parkland.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Close to Donaldson Park in Middlesex County",
      "seo_description": "Experience Aspen Court living near Donaldson Park, Middlesex County. Stylish apartments with amenities, close to outdoor fun and activities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "quibbletown-park-nearby-apartments-08854-27",
      "search_query": "Quibbletown Park nearby apartments 08854",
      "category": "Park",
      "h1_title": "Apartments Near Quibbletown Park 08854",
      "h2_subtitle": "Explore nearby apartments close to Quibbletown Park in the 08854 area. Aspen Court offers comfort and convenience in Piscataway, NJ.",
      "page_copy": "Located in the vibrant heart of Piscataway, NJ, Aspen Court Apartment Homes offers stunning one and two-bedroom apartments nearby Quibbletown Park. This charming community provides residents easy access to both urban conveniences and outdoor adventures.\n\nOur amenities, including a sunny swimming pool and expansive clubhouse, are complemented by the proximity to Quibbletown Park, ideal for weekend picnics and leisurely walks. With spacious floor plans and modern finishes, residents can enjoy a stylish living experience while taking advantage of nearby recreational activities in the renowned 08854 area. Aspen Court combines the best of both worlds for an enriching lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Quibbletown Park 08854",
      "seo_description": "Discover Aspen Court's stylish apartments near Quibbletown Park in Piscataway, 08854. Experience modern living with easy park access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "apartments-by-spring-lake-park-piscataway-838",
      "search_query": "apartments by Spring Lake Park Piscataway",
      "category": "Park",
      "h1_title": "Apartments by Spring Lake Park, Piscataway",
      "h2_subtitle": "Find your ideal home near Spring Lake Park in Piscataway. Aspen Court offers modern living with park-side serenity.",
      "page_copy": "Aspen Court Apartment Homes is the perfect choice for those seeking apartments by Spring Lake Park in Piscataway, NJ. Our community offers spacious one and two-bedroom options with exquisite modern kitchens and designer finishes, perfectly tailored for contemporary living.\n\nSettle into a lifestyle enriched with amenities like a luxurious swimming pool and a well-equipped game room. The proximity to Spring Lake Park provides residents with easy access to tranquil nature escapes and scenic walking trails. Enjoy the unique blend of comfort and convenience at Aspen Court, where you can embrace the beauty of park-side living while having modern conveniences at your doorstep.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Spring Lake Park, Piscataway",
      "seo_description": "Explore Aspen Court's modern apartments near Spring Lake Park. Enjoy stylish living with park access in Piscataway.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "rutgers-gardens-vicinity-apartments-nj-745",
      "search_query": "Rutgers Gardens vicinity apartments NJ",
      "category": "Park",
      "h1_title": "Apartments Near Rutgers Gardens NJ",
      "h2_subtitle": "Discover perfect homes in the vicinity of Rutgers Gardens, NJ. Aspen Court offers modern amenities with nature's charm just a stone's throw away.",
      "page_copy": "For those seeking a blend of natural beauty and modern comfort, Aspen Court Apartment Homes is a premier choice in the vicinity of Rutgers Gardens, NJ. Our thoughtfully designed one and two-bedroom apartments provide a serene living environment enriched with high-end amenities.\n\nSituated near the picturesque Rutgers Gardens, residents enjoy easy access to lush landscapes and vibrant plant life, perfect for relaxation and afternoon strolls. The community amenities, including an expansive sundeck with lounge chairs, further enhance the lifestyle experience. Discover the balance of tranquility and convenience at Aspen Court, just minutes from the renowned gardens and vibrant Middlesex County offerings.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Rutgers Gardens NJ",
      "seo_description": "Find modern living at Aspen Court, near Rutgers Gardens NJ. Enjoy nature and convenience in our well-appointed apartments.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "middlesex-county-open-space-area-apartments-146",
      "search_query": "Middlesex County Open Space area apartments",
      "category": "Park",
      "h1_title": "Apartments in Middlesex County Open Space",
      "h2_subtitle": "Find spacious living options in the Middlesex County Open Space area. Aspen Court offers a perfect blend of nature and modern amenities.",
      "page_copy": "Aspen Court Apartment Homes stands out as a premier choice for those wanting to live near the Middlesex County Open Space area. Offering one and two-bedroom layouts, these apartments provide an ideal living environment for those seeking modern amenities amidst natural surroundings.\n\nNestled in the heart of Piscataway, NJ, our community offers access to serene walking trails, perfect for nature enthusiasts. Enjoy the convenience of being close to the Middlesex County Open Space while relaxing with community amenities like a game room and a vibrant clubhouse. Aspen Court combines the allure of nature with contemporary living, creating a unique residential experience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments in Middlesex County Open Space",
      "seo_description": "Discover Aspen Court, offering modern apartments in the Middlesex County Open Space area. Enjoy a nature-filled, stylish lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "roosevelt-park-surrounding-area-apartments-567",
      "search_query": "Roosevelt Park surrounding area apartments",
      "category": "Park",
      "h1_title": "Apartments Near Roosevelt Park",
      "h2_subtitle": "Explore living options in the Roosevelt Park surrounding area. Aspen Court offers modern amenities in a prime location.",
      "page_copy": "Aspen Court Apartment Homes is your home base near the inspiring Roosevelt Park, providing a perfect blend of modern conveniences and scenic tranquility. Our spacious one and two-bedroom apartments offer contemporary finishes and are thoughtfully designed with comfort in mind.\n\nLocated in the vibrant Middlesex County, Aspen Court provides easy access to the delightful walking trails and lush greenery of Roosevelt Park. With amenities like a sparkling swimming pool and an exciting game room, our pet-friendly community is ideal for those who enjoy both relaxation and adventure. Embrace a lifestyle close to nature while enjoying all the comforts of modern living at Aspen Court.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Roosevelt Park",
      "seo_description": "Live near Roosevelt Park at Aspen Court. Find modern apartments with easy access to nature and vibrant community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "apartments-close-to-washington-rock-state-park-933",
      "search_query": "apartments close to Washington Rock State Park",
      "category": "Park",
      "h1_title": "Apartments by Washington Rock State Park",
      "h2_subtitle": "Discover ideal living with Aspen Court's proximity to Washington Rock State Park. Enjoy modern amenities with stunning park views.",
      "page_copy": "Situated just a short drive from Washington Rock State Park, Aspen Court Apartment Homes offers an exceptional living experience infused with both serenity and convenience. Choose from spacious one and two-bedroom apartments that are designed with the modern resident in mind, complete with chic finishes and contemporary kitchens.\n\nBeyond the comfort of your apartment, enjoy a suite of community amenities including a vibrant clubhouse and expansive sundeck that complement the natural beauty surrounding our community. Immerse yourself in outdoor adventures at Washington Rock State Park, where you can enjoy sweeping views and scenic trails, all while enjoying the comforts of home at Aspen Court.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments by Washington Rock State Park",
      "seo_description": "Find your home at Aspen Court, close to Washington Rock State Park. Enjoy modern living amid natural beauty and exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "apartment-homes-near-peter-j-barnes-wildlife-preserve-212",
      "search_query": "apartment homes near Peter J. Barnes III Wildlife Preserve",
      "category": "Park",
      "h1_title": "Apartment Homes Near Peter J. Barnes Preserve",
      "h2_subtitle": "Explore Aspen Court's proximity to Peter J. Barnes III Wildlife Preserve. Enjoy modern living immersed in nature.",
      "page_copy": "Aspen Court Apartment Homes provides a perfect sanctuary for those wishing to reside close to the mesmerizing Peter J. Barnes III Wildlife Preserve. Our one and two-bedroom apartments offer spacious layouts and stylish finishes that cater to all your living needs.\n\nSituated in the heart of Piscataway, NJ, our community allows residents to indulge in the tranquil beauty of the nearby wildlife preserve. Enjoy peaceful walks through nature while having access to amenities like a refreshing pool and a game room. Aspen Court combines the idyllic setting of the Peter J. Barnes III Wildlife Preserve with the convenience of modern apartment living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartment Homes Near Peter J. Barnes Preserve",
      "seo_description": "Live near the Peter J. Barnes III Wildlife Preserve at Aspen Court. Enjoy modern apartments and access to nature and community amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "ambrose-doty-county-park-nearby-rentals-908",
      "search_query": "Ambrose Doty County Park nearby rentals",
      "category": "Park",
      "h1_title": "Rentals Near Ambrose Doty County Park",
      "h2_subtitle": "Discover Aspen Court's proximity to Ambrose Doty County Park. Enjoy ideal rentals with premier amenities in a vibrant community.",
      "page_copy": "Experience the convenience of living near Ambrose Doty County Park with Aspen Court Apartment Homes in Piscataway, NJ. Our community offers spacious one and two-bedroom rentals with modern finishes and thoughtfully designed layouts. \n\nSurrounded by the lush scenery of Middlesex County, Aspen Court is close to the recreational opportunities available at Ambrose Doty County Park, perfect for those who love the outdoors. Enjoy community amenities, such as a swimming pool and clubhouse, enhancing your living experience. Aspen Court combines the beauty of nearby parks with luxurious apartment living.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals Near Ambrose Doty County Park",
      "seo_description": "Find ideal rentals at Aspen Court, close to Ambrose Doty County Park. Enjoy modern amenities and a vibrant location in Piscataway.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162442",
      "property_id": "6767906449166309",
      "source": "custom",
      "page_item_url": "apartments-near-newark-liberty-international-airport-218",
      "search_query": "apartments near newark liberty international airport nj",
      "category": "Transit",
      "h1_title": "Apartments Near Newark Liberty Airport",
      "h2_subtitle": "Find convenience living near Newark Liberty International Airport. Aspen Court offers modern comforts with easy airport access.",
      "page_copy": "Aspen Court Apartment Homes are ideally located for those needing quick access to Newark Liberty International Airport in NJ, offering convenience paired with luxury living. Choose from our spacious one and two-bedroom apartments, featuring contemporary kitchens and elegant finishes.\n\nSituated in the heart of Piscataway, NJ, our community ensures a hassle-free commute to the airport while providing resident-friendly amenities. Take advantage of our expansive sundeck, game room, and pet-friendly environment. Aspen Court combines proximity to major travel hubs with unmatched residential comforts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
      "featured_image_media": {
        "alt_text": "Apartment complex courtyard with outdoor swimming pool, lounge chairs, seating areas, pergolas, and landscaping.",
        "public_id": "01a015d9-2514-773a-ba3a-cdb5c26a8f4d",
        "storage_key": "property/6767906449166309/01a015d9-2514-773a-ba3a-cdb5c26a8f4d.webp",
        "width": 1920,
        "height": 1279
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Newark Liberty Airport",
      "seo_description": "Live at Aspen Court, conveniently near Newark Liberty International Airport, NJ. Enjoy modern apartment amenities and easy travel access.",
      "include_apartmentsync": "false",
      "status": [
        "Active"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "jordanh@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5047"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "9976232062"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "4973261"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NC9NW34R"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://liveaspencourt.fatwin.com/api/websites/resources/1?x=cmJnRDBJandwL3c5UWFsaWY2WGVjL1ZVUk53VVFPUkZqbDhzYWFvZFRNSjducTFTdXRzZDhwRTJWQVJNR3NrSFQ4aFVLRmhsUk5JV1hIZ1dkYXJLTFE9PQ2"
    },
    {
      "ID": "custom_vibesites_theme",
      "type": "STRING",
      "value": "Belmont"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_engrain_sitemap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/rxwjqnldv1e"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "95497b26-43e6-11ef-8605-8373959e692c"
    },
    {
      "ID": "custom_eliseai_tour_scheduler",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95497b26-43e6-11ef-8605-8373959e692c/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "4bbc32e5-b155-40a7-886b-b483419a5646"
    },
    {
      "ID": "custom_eliseai_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>"
    },
    {
      "ID": "custom_eliseai_tour_scheduler_url",
      "type": "STRING",
      "value": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95497b26-43e6-11ef-8605-8373959e692c/tour?hideScrollBars=true"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6IjYvV0VmN1FsaDB6RlpGaGdROXpnMmc9PSIsInZhbHVlIjoiNE5ZT0phWlFSQWNBVC9JWVhIZlVRUT09IiwibWFjIjoiZWU5NmE3MzI5Njc1NjRmNGNlMzQyNDQ1NTE5YTZlNGY0ODkzYzgwNjNmMDNlMTk0NjE3OWI1NGEyOWEwNzIwMiJ9"
    },
    {
      "ID": "custom_loft_resident_download_apple",
      "type": "STRING",
      "value": "https://apps.apple.com/us/app/loft-living/id333244247"
    },
    {
      "ID": "custom_loft_resident_download_google",
      "type": "STRING",
      "value": "https://play.google.com/store/apps/details?id=com.activebuilding.residents"
    }
  ],
  "custom_csm": "jordanh@repli360.com",
  "custom_qb_id": "5047",
  "custom_repli_id": "9976232062",
  "custom_realpage_id": "4973261",
  "custom_google_gtm_id": "GTM-NC9NW34R",
  "custom_perq_script_url": "https://liveaspencourt.fatwin.com/api/websites/resources/1?x=cmJnRDBJandwL3c5UWFsaWY2WGVjL1ZVUk53VVFPUkZqbDhzYWFvZFRNSjducTFTdXRzZDhwRTJWQVJNR3NrSFQ4aFVLRmhsUk5JV1hIZ1dkYXJLTFE9PQ2",
  "custom_vibesites_theme": "Belmont",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "essential",
  "custom_engrain_sitemap_url": "https://sightmap.com/embed/rxwjqnldv1e",
  "custom_social_subscription": "none",
  "custom_website_subscription": "turnkey",
  "custom_eliseai_building_token": "95497b26-43e6-11ef-8605-8373959e692c",
  "custom_eliseai_tour_scheduler": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95497b26-43e6-11ef-8605-8373959e692c/tour?hideScrollBars=true",
  "custom_eliseai_organization_id": "4bbc32e5-b155-40a7-886b-b483419a5646",
  "custom_eliseai_tour_button_popup": "<button onclick=\"window.eliseAi.onOpenSST()\">Schedule A Tour</button>",
  "custom_eliseai_tour_scheduler_url": "https://app.meetelise.com/4bbc32e5-b155-40a7-886b-b483419a5646/95497b26-43e6-11ef-8605-8373959e692c/tour?hideScrollBars=true",
  "custom_apartmentsync_javascript_id": "eyJpdiI6IjYvV0VmN1FsaDB6RlpGaGdROXpnMmc9PSIsInZhbHVlIjoiNE5ZT0phWlFSQWNBVC9JWVhIZlVRUT09IiwibWFjIjoiZWU5NmE3MzI5Njc1NjRmNGNlMzQyNDQ1NTE5YTZlNGY0ODkzYzgwNjNmMDNlMTk0NjE3OWI1NGEyOWEwNzIwMiJ9",
  "custom_loft_resident_download_apple": "https://apps.apple.com/us/app/loft-living/id333244247",
  "custom_loft_resident_download_google": "https://play.google.com/store/apps/details?id=com.activebuilding.residents",
  "custom_audioeye_site_id": "c04cff99-ec43-4369-b24f-bb1579780960",
  "custom_audioeye_site_hash": "db0b54d4131d36ae00af277a661a3444"
};

export const generatedAt = '2026-10-22T20:07:46.471Z';
